(function () {
  'use strict';

  // ─── Bootstrap ───────────────────────────────────────────────────────────

  var root = document.getElementById('order-catering-root');
  if (!root || root.dataset.ocInitialized) return;
  root.dataset.ocInitialized = '1';

  var CONFIG = {
    locale:                    root.dataset.locale || 'en',
    currency:                  root.dataset.currency || 'CAD',
    emailjsPublicKey:          root.dataset.emailjsPublicKey || '',
    emailjsServiceId:          root.dataset.emailjsServiceId || '',
    emailjsCustomerTemplate:   root.dataset.emailjsCustomerTemplate || '',
    emailjsRestaurantTemplate: root.dataset.emailjsRestaurantTemplate || '',
    adminApiUrl:               root.dataset.adminApiUrl || '',
    adminProxyPath:            (root.dataset.adminProxyPath || '').replace(/\/+$/, ''),
    adminPageHandle:           root.dataset.adminPageHandle || '',
    enableCutoff:              root.dataset.enableCutoff === 'true',
    cutoffDatetime:            root.dataset.cutoffDatetime || '',
    closedMessage:             root.dataset.closedMessage || 'Orders are now closed.',
    hiddenCategories:          (root.dataset.hiddenCategories || '').split('\n').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean),
    featuredCategories:        (root.dataset.featuredCategories || '').split('\n').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean),
    enableSectionNav:          root.dataset.enableSectionNav === 'true',
    groupAddons:               root.dataset.groupAddons === 'true',
  };

  // Accept either a base URL or the full /api/orders endpoint — normalise to
  // a base so we can construct both /api/orders and /api/menu.
  var ADMIN_BASE = (CONFIG.adminApiUrl || '')
    .replace(/\/api\/orders\/?$/, '')
    .replace(/\/+$/, '');
  // Pass through any ?preview=<uuid>,... from the page URL so admins can view
  // inactive pages/packages. Skip caching whenever preview is active.
  var PREVIEW_TOKENS = '';
  try {
    PREVIEW_TOKENS = (new URLSearchParams(window.location.search).get('preview') || '').trim();
  } catch (_) {}
  var MENU_QS = [];
  if (CONFIG.adminPageHandle) MENU_QS.push('page=' + encodeURIComponent(CONFIG.adminPageHandle));
  if (PREVIEW_TOKENS) MENU_QS.push('preview=' + encodeURIComponent(PREVIEW_TOKENS));
  var ADMIN_MENU_URL = ADMIN_BASE
    ? (ADMIN_BASE + '/api/menu' + (MENU_QS.length ? '?' + MENU_QS.join('&') : ''))
    : '';
  // Catering checkout endpoint — saves the order and (for online) creates a
  // Shopify draft order, returning its hosted invoice URL to redirect to.
  // Posts through the same-origin Shopify App Proxy so Shopify signs the request
  // (no API key in the page). Shopify forwards <proxy>/checkout to the admin
  // app's /api/checkout with a verified signature.
  var ADMIN_CHECKOUT_URL = CONFIG.adminProxyPath
    ? (CONFIG.adminProxyPath + '/checkout')
    : '';
  // Keyed per admin page handle — each catering page caches its own menu, so
  // a failed fetch on one page can never fall back to another page's menu.
  var MENU_CACHE_KEY = 'chezg_order_catering_menu_v1:' + (CONFIG.adminPageHandle || 'default');
  var PREVIEW_MODE = !!PREVIEW_TOKENS;

  // ─── Build menu map from DOM (populated after renderMenu) ────────────────

  var menuItems = {};
  var itemOptionGroups = {}; // itemId -> parsed option groups array
  var sizeContentsByItem = {}; // itemId -> [ [lines for size 0], [size 1], ... ]
  var activeSizeIndexByItem = {}; // itemId -> selected size index (default 0)
  // Default lead time used for any item without its own override. Set from
  // the API's pickup.buffer_hours once the menu loads; the fallback keeps the
  // warning logic functional if the API shape is older.
  var pageBufferHours = 48;

  function populateMenuItems() {
    menuItems = {};
    root.querySelectorAll('[data-item-id]').forEach(function (el) {
      menuItems[el.dataset.itemId] = {
        name:  el.dataset.itemName || '',
        price: parseFloat(el.dataset.itemPrice) || 0,
        minQty: el.dataset.itemMin ? parseInt(el.dataset.itemMin) : 0,
        // null = no item-specific override; fall back to pageBufferHours.
        leadHours: el.dataset.itemLead ? parseFloat(el.dataset.itemLead) : null,
      };
    });
  }

  function slugify(str) {
    return String(str).toLowerCase().trim()
      .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  // ─── Load menu from admin /api/menu (Supabase) ────────────────────────────
  //
  // The API returns bilingual data with nested {en, fr} objects. The render
  // code below still uses the legacy `_en`/`_fr` parallel-field shape from
  // the metaobject era, so we adapt the payload at the fetch boundary to
  // keep the render diff minimal.

  function showMenuError() {
    var menuEl = document.getElementById('oc-menu');
    if (!menuEl) return;
    // Fetch failed: drop the loading state so the snapshot (or error) shows.
    document.documentElement.classList.remove('oc-js');
    // If the server-rendered SEO snapshot is still in place (live fetch failed
    // and there's no cache), keep it — a slightly stale real menu beats an
    // error message. The snapshot uses the same .menu-* markup as renderMenu.
    if (menuEl.querySelector('.menu-package, .menu-category, .menu-item-wrap')) return;
    menuEl.innerHTML =
      '<p style="padding:1rem;text-align:center;color:rgba(var(--color-foreground),0.6);">' +
      (CONFIG.locale === 'fr'
        ? 'Le menu est temporairement indisponible. Veuillez réessayer dans un instant.'
        : 'Menu is temporarily unavailable. Please try again in a moment.') +
      '</p>';
  }

  function loadMenuFromApi() {
    if (!ADMIN_MENU_URL) return Promise.resolve(null);
    // Cache-bust via query param rather than `cache: 'no-store'`. Safari/WebKit
    // attaches Cache-Control/Pragma request headers for no-store on cross-origin
    // fetches, forcing a preflight the admin API doesn't allow → the request
    // fails in Safari (works in Chrome). The server already sends
    // `max-age=0, must-revalidate`, so the param just guarantees a fresh copy.
    var url = ADMIN_MENU_URL + (ADMIN_MENU_URL.indexOf('?') === -1 ? '?' : '&') + '_=' + Date.now();
    return fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (payload) {
        // Never cache preview payloads — they contain unreleased content.
        if (!PREVIEW_MODE) {
          try { localStorage.setItem(MENU_CACHE_KEY, JSON.stringify(payload)); } catch (_) {}
        }
        return payload;
      })
      .catch(function (err) {
        console.warn('[menu] Live fetch failed; falling back to cache.', err);
        if (PREVIEW_MODE) return null;
        try {
          var cached = localStorage.getItem(MENU_CACHE_KEY);
          if (cached) return JSON.parse(cached);
        } catch (_) {}
        return null;
      });
  }

  // Transform API options (denormalised) into the shape parseOptionGroups()
  // expects. Group + choice FR names come from group_fr / choice name_fr; each
  // falls back to EN at render time (parseOptionGroups) when blank.
  function adaptOptionsToGroups(apiOpts) {
    if (!Array.isArray(apiOpts)) return [];
    return apiOpts.map(function (o) {
      var choices = Array.isArray(o.choices) ? o.choices : [];
      var normChoices = choices.map(function (c) {
        return {
          name_en:   c.name_en || c.name || '',
          name_fr:   c.name_fr || '',
          price_adj: parseFloat(c.price_adj) || 0,
        };
      });
      return {
        handle:         slugify(o.group || ''),
        name_en:        o.group || '',
        name_fr:        o.group_fr || '',
        selection_type: o.type === 'multi_qty' ? 'multi_qty' : 'radio',
        required:       false,
        choices_json:   JSON.stringify(normChoices),
      };
    });
  }

  // Which kind of group this is, asked of a *raw* adapted group.
  //
  // adaptOptionsToGroups() above stores the kind as `selection_type`, because
  // that is the shape parseOptionGroups() consumes — and the item path always
  // goes through parseOptionGroups, which normalises it back to `.type`. The
  // package configuration modal reads its groups raw, without that step, so
  // asking for `g.type` there returned undefined for every group and every
  // package option rendered as a quantity stepper: radio groups included.
  function groupSelectionType(g) {
    var t = g && (g.selection_type || g.type);
    return t === 'multi_qty' ? 'multi_qty' : 'radio';
  }

  // A single size button's label: the size name and its servings joined by a
  // space, or whichever is present. Mirrors sizeButtonLabel() in the admin so
  // the preview there matches the live button exactly.
  function joinSizeLabel(name, serves) {
    if (name && serves) return name + ' ' + serves;
    return name || serves || '';
  }

  // Servings as a bare parenthetical "(x–y)" for the size buttons — locale
  // neutral (no "Serves"/"Pour" word). Returns '' when neither bound is set.
  function servingsParens(min, max) {
    var a = parseInt(min, 10);
    var b = parseInt(max, 10);
    if (isNaN(a) && isNaN(b)) return '';
    if (isNaN(a)) a = b;
    if (isNaN(b)) b = a;
    if (a > b) { var t = a; a = b; b = t; }
    return '(' + (a === b ? String(a) : (a + '–' + b)) + ')';
  }

  // One option group's panel HTML (radio or multi_qty), keyed by its handle.
  // Shared by item-level and per-size option rendering.
  function optionGroupHtml(id, g) {
    var groupKey = g.handle || slugify(g.name_en) || 'group';
    var h = '<div class="option-group" data-option-group="' + escAttr(groupKey) + '" data-option-type="' + escAttr(g.type) + '">';
    h += '<div class="option-group__label">' + esc(g.name);
    if (g.required) h += ' <span class="option-group__req">*</span>';
    h += '</div>';
    if (g.type === 'radio') {
      g.choices.forEach(function (c, ci) {
        h += '<label class="option-choice option-choice--radio">';
        h += '<input type="radio" name="' + escAttr(id + '-' + groupKey) + '" value="' + escAttr(c.key) + '"' + (ci === 0 ? ' checked' : '') + '>';
        h += '<span class="option-choice__name">' + esc(c.name) + '</span>';
        if (c.price_adj > 0) h += '<span class="option-choice__adj">+$' + c.price_adj.toFixed(2) + '</span>';
        h += '</label>';
      });
    } else if (g.type === 'multi_qty') {
      g.choices.forEach(function (c) {
        h += '<div class="option-choice option-choice--multi">';
        h += '<span class="option-choice__name">' + esc(c.name) + '</span>';
        if (c.price_adj > 0) h += '<span class="option-choice__adj">+$' + c.price_adj.toFixed(2) + '</span>';
        h += '<div class="qty-control qty-control--sm" data-sub-qty="' + escAttr(id) + '" data-sub-group="' + escAttr(groupKey) + '" data-sub-choice="' + escAttr(c.key) + '">';
        h += '<button class="qty-btn qty-minus" type="button" aria-label="Remove">−</button>';
        h += '<span class="qty-value">0</span>';
        h += '<button class="qty-btn qty-plus" type="button" aria-label="Add">+</button>';
        h += '</div></div>';
      });
    }
    h += '</div>'; // option-group
    return h;
  }

  // A size's contents as display lines ("{amount} {name}"), for the selected
  // locale. Empty when the size has no structured contents (→ description
  // fallback). Used both for the initial render and the live size-swap.
  function sizeContentLines(size, isFr) {
    var out = [];
    ((size && size.contents) || []).forEach(function (c) {
      var nm = (c.name && (isFr ? (c.name.fr || c.name.en) : (c.name.en || c.name.fr))) || '';
      var amt = c.amount || '';
      var line = (amt && nm) ? (amt + ' ' + nm) : (amt || nm);
      if (line) out.push(line);
    });
    return out;
  }

  // Structured sizes (admin `sizes` field) → a synthesized "Size" radio group,
  // so all the existing option plumbing (inline buttons, cart, summary,
  // checkout) applies unchanged. Only 2+ sizes become buttons; a lone size is
  // the servings pill (handled by the API folding it into servings_min/max).
  // Each choice label combines the size's own name with the auto-generated
  // "Serves …" string, so the servings wording can never drift between
  // platters. price_adj is relative to the item price, which the API guarantees
  // equals the cheapest size. Any manually entered "Size" group is dropped in
  // favour of the structured one.
  function applyStructuredSizes(it, groups) {
    var sizes = Array.isArray(it.sizes) ? it.sizes : [];
    if (sizes.length < 2) return groups;
    var base = parseFloat(it.price) || 0;
    var choices = sizes.map(function (s) {
      var labelEn = (s.label && s.label.en) || '';
      var labelFr = (s.label && s.label.fr) || labelEn;
      var serves = servingsParens(s.servings_min, s.servings_max);
      return {
        name_en:   joinSizeLabel(labelEn, serves),
        name_fr:   joinSizeLabel(labelFr, serves),
        price_adj: (parseFloat(s.price) || 0) - base,
      };
    });
    var out = groups.filter(function (g) {
      return (g.handle || slugify(g.name_en || '')) !== 'size';
    });
    out.push({
      handle:         'size',
      name_en:        'Size',
      name_fr:        'Format',
      selection_type: 'radio',
      required:       false,
      choices_json:   JSON.stringify(choices),
    });
    return out;
  }

  // Build the "Serves …" label from a min/max integer range so the wording is
  // consistent across platters. Returns '' when neither bound is set.
  function formatServings(min, max, isFr) {
    var a = parseInt(min, 10);
    var b = parseInt(max, 10);
    if (isNaN(a) && isNaN(b)) return '';
    if (isNaN(a)) a = b;
    if (isNaN(b)) b = a;
    if (a > b) { var t = a; a = b; b = t; }
    if (isFr) {
      return 'Pour ' + (a === b ? String(a) : (a + ' à ' + b));
    }
    return 'Serves ' + (a === b ? String(a) : (a + '–' + b));
  }

  // Flatten API payload ({ packages, categories }) into the two arrays the
  // renderMenu() signature expects: packages and items (with category_en/fr
  // stamped on each item from the containing category).
  function adaptPayloadForRender(payload) {
    var packages = (payload && payload.packages || []).map(function (p) {
      return {
        handle:      p.handle,
        name_en:     (p.name && p.name.en) || '',
        name_fr:     (p.name && p.name.fr) || '',
        subtitle_en: (p.subtitle && p.subtitle.en) || '',
        subtitle_fr: (p.subtitle && p.subtitle.fr) || '',
        badge_en:    (p.badge && p.badge.en) || '',
        badge_fr:    (p.badge && p.badge.fr) || '',
        includes_en: (p.includes && p.includes.en) || '',
        includes_fr: (p.includes && p.includes.fr) || '',
        price:       p.price,
        // Per-package lead time. Not yet exposed by the API — falls back to
        // the page's default buffer at compare time when null.
        lead_time_hours: p.lead_time_hours == null ? null : Number(p.lead_time_hours),
        background:  p.background || 'dill',
        outline:     p.outline || 'gold',
        items:       (p.items || []).map(function (pi) {
          // name/desc/options are embedded on the pivot row now; fall back to
          // the page-scoped lookup for older payload shapes.
          return {
            id:            pi.id,
            quantity:      pi.quantity,
            name_en:       (pi.name && pi.name.en) || '',
            name_fr:       (pi.name && pi.name.fr) || '',
            desc_en:       (pi.desc && pi.desc.en) || '',
            desc_fr:       (pi.desc && pi.desc.fr) || '',
            // Portion sold ("8oz"), one string for both locales. Absent in
            // older payloads → '' → nothing renders.
            size:          pi.size || '',
            // Section heading ({en,fr}|null) — members arrive pre-ordered by
            // section; the renderer inserts a heading row on label change.
            section:       (pi.section && (pi.section.en || pi.section.fr))
              ? { en: pi.section.en || '', fr: pi.section.fr || '' }
              : null,
            // À-la-carte unit price (109): prices over-target picks and
            // suggested add-ons. Absent in older payloads → 0 = unknown.
            price:         parseFloat(pi.price) || 0,
            // true = optional add-on offered in the config panel, not
            // included contents (109).
            suggested:     pi.suggested === true,
            option_groups: adaptOptionsToGroups(pi.options || []),
          };
        }),
      };
    });

    var items = [];

    // Normal shape: items nested under categories.
    (payload && payload.categories || []).forEach(function (cat) {
      (cat.items || []).forEach(function (it) {
        items.push({
          handle:        it.id,
          name_en:       (it.name && it.name.en) || '',
          name_fr:       (it.name && it.name.fr) || '',
          desc_en:       (it.desc && it.desc.en) || '',
          desc_fr:       (it.desc && it.desc.fr) || '',
          size:          it.size || '',
          lead_en:       (it.lead && it.lead.en) || '',
          lead_fr:       (it.lead && it.lead.fr) || '',
          badge_en:      (it.badge && it.badge.en) || '',
          badge_fr:      (it.badge && it.badge.fr) || '',
          servings_min:  it.servings_min == null ? null : it.servings_min,
          servings_max:  it.servings_max == null ? null : it.servings_max,
          image_url:     it.image_url || '',
          // Per-menu featuring (admin migration 156): the key is emitted only
          // on items this menu has featured, so absent → false.
          featured:      it.featured === true,
          // ...and whether that featured card carries the photo (158). Emitted
          // only when it does NOT, so absent → true: every payload written
          // before 158 meant a card with its photo.
          featured_image: it.featured_image !== false,
          // ...and where it stands among this menu's featured cards (179): a
          // dense 0-based rank, emitted on every featured item of a menu or
          // on none of them. Absent → null, never 0 — an older admin has not
          // ranked anything, and the hoisted grid keeps the order it is found
          // in. Never read for anything but that sort.
          featured_order: typeof it.featured_order === 'number' ? it.featured_order : null,
          category_en:   (cat.name && cat.name.en) || '',
          category_fr:   (cat.name && cat.name.fr) || '',
          min_qty:       it.min_quantity || '',
          price:         it.price,
          sizes:         Array.isArray(it.sizes) ? it.sizes : [],
          // Per-item lead time. Not yet exposed by the API — falls back to
          // the page's default buffer at compare time when null.
          lead_time_hours: it.lead_time_hours == null ? null : Number(it.lead_time_hours),
          option_groups: applyStructuredSizes(it, adaptOptionsToGroups(it.options)),
        });
      });
    });

    // Flat shape: page has show_categories=false. Items come back as a top
    // level array with no category grouping. Stamp an empty category so the
    // renderer puts them in a single unheaded bucket.
    (payload && payload.items || []).forEach(function (it) {
      items.push({
        handle:        it.id,
        name_en:       (it.name && it.name.en) || '',
        name_fr:       (it.name && it.name.fr) || '',
        desc_en:       (it.desc && it.desc.en) || '',
        desc_fr:       (it.desc && it.desc.fr) || '',
        size:          it.size || '',
        lead_en:       (it.lead && it.lead.en) || '',
        lead_fr:       (it.lead && it.lead.fr) || '',
        badge_en:      (it.badge && it.badge.en) || '',
        badge_fr:      (it.badge && it.badge.fr) || '',
        servings_min:  it.servings_min == null ? null : it.servings_min,
        servings_max:  it.servings_max == null ? null : it.servings_max,
        image_url:     it.image_url || '',
        featured:      it.featured === true,
        featured_image: it.featured_image !== false,
        featured_order: typeof it.featured_order === 'number' ? it.featured_order : null,
        category_en:   '',
        category_fr:   '',
        min_qty:       it.min_quantity || '',
        price:         it.price,
        sizes:         Array.isArray(it.sizes) ? it.sizes : [],
        lead_time_hours: it.lead_time_hours == null ? null : Number(it.lead_time_hours),
        option_groups: applyStructuredSizes(it, adaptOptionsToGroups(it.options)),
      });
    });

    return { packages: packages, items: items };
  }

  // ─── Render menu from fetched data ─────────────────────────────────────

  // Custom package colours (admin migration 108): background/outline may be
  // a "#rrggbb" hex instead of a palette key. Hexes render via inline CSS
  // vars on the card; text and the savings badge flip by luminance, the
  // same rule the admin preview applies.
  var HEX_COLOR_RE = /^#[0-9a-f]{6}$/i;
  function hexLuma(hex) {
    var r = parseInt(hex.slice(1, 3), 16),
        g = parseInt(hex.slice(3, 5), 16),
        b = parseInt(hex.slice(5, 7), 16);
    return (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
  }

  function renderMenu(pkgData, itemsData) {
    var menuEl = document.getElementById('oc-menu');
    if (!menuEl) return;

    var isFr = CONFIG.locale === 'fr';
    var html = '';
    // Reset per-render lookups (rebuilt below for the live size swap).
    sizeContentsByItem = {};
    activeSizeIndexByItem = {};

    // Build lookups by handle so package cards can render item names, their
    // descriptions, and compute à-la-carte totals (adaptPayloadForRender sets
    // handle = it.id).
    var itemNameByHandle = {};
    var itemDescByHandle = {};
    var itemPriceByHandle = {};
    (itemsData || []).forEach(function (it) {
      itemNameByHandle[it.handle] = (isFr && it.name_fr) ? it.name_fr : (it.name_en || it.handle);
      itemDescByHandle[it.handle] = (isFr && it.desc_fr) ? it.desc_fr : (it.desc_en || '');
      itemPriceByHandle[it.handle] = parseFloat(it.price) || 0;
    });

    // ── Packages ──
    // Reset lookup so a re-render (e.g. locale switch) keeps it current.
    pkgByHandle = {};
    (pkgData || []).forEach(function (pkg) {
      pkgByHandle[pkg.handle] = pkg;
      var name = (isFr && pkg.name_fr) ? pkg.name_fr : (pkg.name_en || 'Unnamed');
      var subtitle = (isFr && pkg.subtitle_fr) ? pkg.subtitle_fr : (pkg.subtitle_en || '');
      var badge = (isFr && pkg.badge_fr) ? pkg.badge_fr : (pkg.badge_en || '');
      var includes = (isFr && pkg.includes_fr) ? pkg.includes_fr : (pkg.includes_en || '');
      var price = parseFloat(pkg.price) || 0;

      var bgKey = typeof pkg.background === 'string' && pkg.background ? pkg.background : 'dill';
      var outlineKey = typeof pkg.outline === 'string' && pkg.outline ? pkg.outline : 'gold';
      var styleVars = [];
      if (HEX_COLOR_RE.test(bgKey)) {
        var bgLuma = hexLuma(bgKey);
        styleVars.push('--mp-bg:' + bgKey.toLowerCase());
        styleVars.push('--mp-text-rgb:' + (bgLuma < 0.6 ? '255 255 255' : '38 37 35'));
        styleVars.push('--mp-savings:' + (bgLuma < 0.6 ? '#4ade80' : '#15803d'));
        bgKey = 'custom';
      }
      if (HEX_COLOR_RE.test(outlineKey)) {
        styleVars.push('--mp-outline:' + outlineKey.toLowerCase());
        outlineKey = 'custom';
      }
      var pkgLeadAttr = pkg.lead_time_hours != null
        ? ' data-item-lead="' + pkg.lead_time_hours + '"'
        : '';
      html += '<div class="menu-package menu-package--bg-' + escAttr(bgKey) +
        ' menu-package--outline-' + escAttr(outlineKey) +
        '"' + (styleVars.length ? ' style="' + styleVars.join(';') + '"' : '') +
        ' data-item-id="pkg-' + pkg.handle + '" data-item-name="' + escAttr(name) + '" data-item-price="' + price.toFixed(2) + '"' + pkgLeadAttr + '>';
      if (badge) html += '<div class="menu-package__badge">' + esc(badge) + '</div>';
      html += '<div class="menu-package__header">';
      html += '<span class="menu-package__name">' + esc(name) + '</span>';
      html += '<span class="menu-package__price">$' + price.toFixed(2) + '</span>';
      html += '</div>';
      if (pkg.items && pkg.items.length && price > 0) {
        var alaCarte = 0;
        pkg.items.forEach(function (pi) {
          if (pi.suggested) return; // add-ons aren't in the package price
          var unit = pi.price || itemPriceByHandle[pi.id] || 0;
          var qty = parseInt(pi.quantity, 10) || 1;
          alaCarte += unit * qty;
        });
        if (alaCarte > price) {
          var pct = Math.round(((alaCarte - price) / alaCarte) * 100);
          var saveLabel = isFr ? 'Économisez ' : 'Save ';
          html += '<div class="menu-package__savings">' + esc(saveLabel) + pct + '%</div>';
        }
      }
      if (subtitle) html += '<p class="menu-package__subtext">' + esc(subtitle) + '</p>';
      html += '<hr class="menu-package__divider">';
      if (includes) html += '<div class="menu-package__includes">' + esc(includes) + '</div>';
      if (pkg.items && pkg.items.length) {
        // The full contents always render; the list is height-capped with
        // internal scroll (CSS max-height on .menu-package__contents), so
        // the card's header and footer stay put however long the menu is.
        // "Show all" expands the cap; the button is hidden after mount for
        // lists that fit (see the measurement pass below renderMenu).
        var hasSections = pkg.items.some(function (pi) {
          return pi.section && (pi.section.en || pi.section.fr);
        });
        var prevSection = '';
        // The well wraps the scroll area: when the list overflows, the well
        // gets the inset "page inside the card" styling (darkened ground +
        // inner shadow) whose frame stays crisp while the masked content
        // fades inside it — a fade on the list itself would dissolve the
        // well's own bottom edge.
        html += '<div class="menu-package__contents-well">';
        html += '<ul class="menu-package__contents' +
          (hasSections ? ' menu-package__contents--sectioned' : '') + '">';
        pkg.items.forEach(function (pi) {
          // Suggested add-ons (109) live in the config panel, not the
          // included-contents list.
          if (pi.suggested) return;
          // Prefer the name/desc embedded on the pivot row (works for items
          // that aren't on the current page); fall back to the page lookup.
          var embeddedName = isFr ? (pi.name_fr || pi.name_en) : (pi.name_en || pi.name_fr);
          var embeddedDesc = isFr ? (pi.desc_fr || pi.desc_en) : (pi.desc_en || pi.desc_fr);
          var itemName = embeddedName || itemNameByHandle[pi.id] || pi.id;
          var itemDesc = embeddedDesc || itemDescByHandle[pi.id] || '';
          var qty = parseInt(pi.quantity, 10) || 1;
          if (hasSections) {
            var sectionLabel = pi.section
              ? (isFr ? (pi.section.fr || pi.section.en) : (pi.section.en || pi.section.fr)) || ''
              : '';
            if (sectionLabel && sectionLabel !== prevSection) {
              html += '<li class="menu-package__section-title"><span>' + esc(sectionLabel) + '</span></li>';
            }
            prevSection = sectionLabel;
          }
          // Only prefix qty when > 1 — "1 × Fruit salad" reads as noise.
          var qtyPrefix = qty > 1 ? (qty + ' × ') : '';
          var itemSize = pi.size || '';
          var descHtml = (itemSize ? '<span class="menu-package__item-size">' + esc(itemSize) + '</span>' : '')
            + (itemDesc
              ? '<span class="menu-package__item-desc">' + esc(itemDesc) + '</span>'
              : '');
          html += '<li><span>' + qtyPrefix + esc(itemName) + descHtml + '</span></li>';
        });
        html += '</ul></div>';
        var moreLabel = isFr ? 'Tout afficher' : 'Show all';
        var lessLabel = isFr ? 'Voir moins' : 'Show less';
        html += '<button type="button" class="menu-package__more" data-more="'
          + escAttr(moreLabel) + '" data-less="' + escAttr(lessLabel) + '">'
          + esc(moreLabel) + '</button>';
      }
      // Footer (the package count) sits ABOVE the options panel, so adding
      // more packages never chases the qty control down the card.
      html += '<div class="menu-package__footer">';
      html += '<div class="qty-control" data-qty-item="pkg-' + pkg.handle + '">';
      html += '<button class="qty-btn qty-minus" type="button" aria-label="Remove">−</button>';
      html += '<span class="qty-value">0</span>';
      html += '<button class="qty-btn qty-plus" type="button" aria-label="Add">+</button>';
      html += '</div></div>';
      // Inline options panel — expands below the footer when the package is
      // added, the same way an item's options panel does (this replaced the
      // old configuration modal). Content is (re)rendered by
      // renderPackageConfig because multi-qty targets scale with how many
      // of the package are ordered.
      if (packageNeedsConfiguration(pkg)) {
        html += '<div class="menu-package__config" data-pkg-config="pkg-' +
          escAttr(pkg.handle) + '" style="display:none"></div>';
      }
      html += '</div>';
    });

    // ── Menu items grouped by category (filter out hidden) ──
    // Empty category stays empty — the render loop then skips the heading
    // and collapse UI so items display as a flat list (used when the admin
    // page has show_categories=false).
    var hidden = CONFIG.hiddenCategories;
    var grouped = {};
    var groupCatEn = {};
    (itemsData || []).forEach(function (item) {
      var catName = (isFr && item.category_fr) ? item.category_fr : item.category_en;
      var cat = catName || '';
      if (cat && hidden.indexOf(cat.toLowerCase()) !== -1) return;
      if (!grouped[cat]) { grouped[cat] = []; groupCatEn[cat] = item.category_en || cat; }
      grouped[cat].push(item);
    });

    // Category order is already set by the admin /api/menu response
    // (catering_categories.sort_order). Insertion order into `grouped`
    // mirrors that, so Object.keys preserves it.
    // Featured categories (section setting, matched on the EN or localized
    // name) are pulled to the top and rendered as an always-open card grid;
    // everything else keeps the accordion layout below the "À la carte" split.
    var isFeaturedCat = function (cat) {
      if (!cat) return false;
      return CONFIG.featuredCategories.indexOf(cat.toLowerCase()) !== -1 ||
        CONFIG.featuredCategories.indexOf((groupCatEn[cat] || '').toLowerCase()) !== -1;
    };

    // ── Per-item featuring (admin migration 156) ──
    // A menu can single out individual items (★ Feature in Catering › Menu ›
    // Menus); /api/menu emits featured:true on those and omits the key
    // otherwise. They are hoisted out of their categories into one synthetic
    // section that renders FIRST through the existing featured branch — a menu
    // that singles out a platter means it to lead. Items already inside a
    // featured CATEGORY are left where they are: featuring the category is how
    // the platters page works, and hoisting out of it would empty it.
    var FEATURED_KEY = '\u0000featured'; // can't collide with a category name
    var hoisted = [];
    Object.keys(grouped).forEach(function (cat) {
      if (isFeaturedCat(cat)) return;
      var keep = [];
      grouped[cat].forEach(function (item) {
        if (item.featured === true) hoisted.push(item);
        else keep.push(item);
      });
      if (keep.length === grouped[cat].length) return;
      // A category emptied by the removal would render as an empty accordion.
      if (keep.length) grouped[cat] = keep;
      else { delete grouped[cat]; delete groupCatEn[cat]; }
    });

    // The order the hoisted cards lead in (admin migration 179). The walk
    // above collects them category by category, so without this the grid's
    // order is a side effect of which section each card came from — two
    // featured items could only be arranged against each other while they
    // shared a category. /api/menu now ranks them over the whole menu
    // (featured_order, dense and 0-based) and the admin has a strip for
    // dragging them; here they are simply sorted by it.
    //
    // Only when EVERY hoisted card carries a rank: a menu served by an older
    // admin carries none, and a comparator that treated some as 0 would
    // shuffle the rest around them. sort() is stable, so equal ranks — and a
    // payload with no ranks at all — keep exactly the order they are found
    // in, which is what this section did before 179.
    if (hoisted.length > 1 && hoisted.every(function (i) { return typeof i.featured_order === 'number'; })) {
      hoisted.sort(function (a, b) { return a.featured_order - b.featured_order; });
    }

    var allKeys = Object.keys(grouped);
    var featuredKeys = allKeys.filter(isFeaturedCat);
    var regularKeys = allKeys.filter(function (c) { return !isFeaturedCat(c); });
    var hoistedKeys = [];
    if (hoisted.length) {
      grouped[FEATURED_KEY] = hoisted;
      hoistedKeys.push(FEATURED_KEY);
    }
    var orderedKeys = hoistedKeys.concat(featuredKeys, regularKeys);
    // How many prominent sections render above the à-la-carte items — the
    // divider's condition and its insertion index are both offsets into
    // orderedKeys, so the hoisted section has to count in both.
    var leadCount = hoistedKeys.length + featuredKeys.length;

    // ── Sticky section nav (menu-page style) ──
    // When on, every real section registers a nav tile (photo + name) and an
    // anchor id; non-featured categories render as open, headed lists instead
    // of accordions; and the "À la carte" divider is suppressed (each section
    // is self-headed). navSections is filled in section order below and turned
    // into the sticky scroll-spy nav after the loop.
    var sectionNav = CONFIG.enableSectionNav;
    var navSections = [];
    var greenTagged = false; // first featured card = the inverted "bubbie" card
    function sectionAnchor(cat) {
      return 'oc-sec-' + (slugify(groupCatEn[cat] || cat) || 'section');
    }
    function sectionRepImage(list) {
      for (var ri = 0; ri < list.length; ri++) {
        if (list[ri].image_url) return list[ri].image_url;
      }
      return '';
    }

    // ── Add-ons umbrella (group_addons) ──
    // With the section nav on, all non-featured categories collapse into one
    // "Add-Ons" section: a single nav tile and green band heading, with each
    // category reduced to a small subheading inside. Keeps the nav short and
    // demotes the sidekick categories (salads, drinks, extras) below the
    // platters instead of giving them equal billing. Flat (uncategorised)
    // items are never grouped.
    var groupAddons = CONFIG.groupAddons && sectionNav;
    var addonsLabel = isFr ? 'Boissons et extras' : 'Drinks and Extras';
    var addonsAnchorId = 'oc-sec-add-ons';
    var addonsOpen = false;
    function addonsRepImage() {
      for (var ai = 0; ai < regularKeys.length; ai++) {
        if (!regularKeys[ai]) continue;
        var img = sectionRepImage(grouped[regularKeys[ai]]);
        if (img) return img;
      }
      return '';
    }

    // Label the individual-items section "À LA CARTE" whenever something more
    // prominent (packages or a featured category) renders above it. Same in
    // EN and FR. Suppressed in section-nav mode, where each section has its own
    // heading.
    var needsAlacarteHeading = !sectionNav &&
      ((pkgData || []).length > 0 || leadCount > 0) && regularKeys.length > 0;
    if (needsAlacarteHeading && leadCount === 0) {
      html += '<h2 class="menu-alacarte-heading">À la carte</h2>';
    }

    orderedKeys.forEach(function (cat, keyIdx) {
      if (needsAlacarteHeading && leadCount > 0 && keyIdx === leadCount) {
        html += '<h2 class="menu-alacarte-heading">À la carte</h2>';
      }
      var items = grouped[cat];
      var flat = !cat;
      // Featured (Platters) cards get the richer layout: photo, lead paragraph,
      // and servings. Regular/flat rows keep the compact two-column layout.
      var isHoisted = cat === FEATURED_KEY;
      var isFeatured = !flat && (isHoisted || isFeaturedCat(cat));
      // Grouped add-on categories share one umbrella section + nav tile
      // instead of registering their own.
      var isAddonSub = groupAddons && !flat && !isFeatured;
      // Register a nav tile + anchor id for every real section in nav mode.
      var anchorId = '';
      if (!flat && sectionNav && !isAddonSub && !isHoisted) {
        anchorId = sectionAnchor(cat);
        navSections.push({ id: anchorId, label: cat, imageUrl: sectionRepImage(items) });
      }
      var idAttr = anchorId ? ' id="' + escAttr(anchorId) + '"' : '';
      if (flat) {
        html += '<div class="menu-category menu-category--flat">';
        html += '<div class="menu-category__items">';
      } else if (isFeatured) {
        html += '<div class="menu-category menu-category--featured"' + idAttr + '>';
        // The hoisted set has no category name to print — a bare grid above
        // the first heading. A per-menu label was offered on the admin side
        // and not taken, so don't invent one here.
        if (!isHoisted) html += '<h2 class="menu-featured-heading">' + esc(cat) + '</h2>';
        html += '<div class="menu-category__items menu-featured-grid">';
      } else if (isAddonSub) {
        // First add-on category opens the umbrella (closed after the loop —
        // regular categories always follow the featured ones, so add-on
        // subsections are contiguous at the end).
        if (!addonsOpen) {
          addonsOpen = true;
          navSections.push({ id: addonsAnchorId, label: addonsLabel, imageUrl: addonsRepImage() });
          html += '<div class="menu-category menu-category--section menu-category--addons" id="' + addonsAnchorId + '">';
          html += '<h2 class="menu-featured-heading">' + esc(addonsLabel) + '</h2>';
        }
        // Two opens (group + items) so the shared two-close at the loop's end
        // leaves the umbrella itself open for the next add-on category.
        html += '<div class="menu-addons-group">';
        html += '<h3 class="menu-addons-subheading">' + esc(cat) + '</h3>';
        html += '<div class="menu-category__items">';
      } else if (sectionNav) {
        // Menu-page style: an open, headed list — no accordion toggle.
        html += '<div class="menu-category menu-category--section"' + idAttr + '>';
        html += '<h2 class="menu-featured-heading">' + esc(cat) + '</h2>';
        html += '<div class="menu-category__items">';
      } else {
        html += '<div class="menu-category collapsed">';
        html += '<div class="menu-category__title">';
        html += '<span>' + esc(cat) + '</span>';
        html += '<span class="menu-category__arrow">▾</span>';
        html += '</div>';
        html += '<div class="menu-category__items">';
      }

      items.forEach(function (item) {
        var name = (isFr && item.name_fr) ? item.name_fr : (item.name_en || 'Unnamed');
        var desc = (isFr && item.desc_fr) ? item.desc_fr : (item.desc_en || '');
        var price = parseFloat(item.price) || 0;
        var minQty = parseInt(item.min_qty) || 0;
        var id = item.handle;
        // Platter card extras — only surfaced in featured cards below.
        var lead = (isFr && item.lead_fr) ? item.lead_fr : (item.lead_en || '');
        var badge = (isFr && item.badge_fr) ? item.badge_fr : (item.badge_en || '');
        var servings = formatServings(item.servings_min, item.servings_max, isFr);
        var imageUrl = item.image_url || '';
        // A featured card is mostly its picture, so an item that has never been
        // photographed reads as a broken card rather than as the thing leading
        // the menu. 158 lets a menu ask for the featured treatment WITHOUT the
        // photo; everything else about the card — badge, servings, lead, the
        // inline size buttons, "What's included" — is what it asked for, so
        // this is the only thing the flag touches. data-has-image and
        // .menu-item--has-photo hang off it, so the card lays itself out as a
        // photoless one with nothing else to change.
        var showImage = isFeatured && imageUrl && item.featured_image !== false;

        // Parse item-level option groups (size-agnostic → sizeIndex null).
        var groups = parseOptionGroups(item.option_groups, isFr);
        groups.forEach(function (g) { g.sizeIndex = null; });

        // Parse per-size option groups (radio; e.g. small = 1 schmear, large =
        // 2). Keys are prefixed with the size index so cartOptions never
        // collides across sizes, and each group is tagged with its owning size
        // so pricing/summary can scope to the selected size. Rendered wrapped by
        // size; only the active size's groups are shown/counted.
        var itemSizesForOpts = Array.isArray(item.sizes) ? item.sizes : [];
        var perSizeGroups = itemSizesForOpts.map(function (s, sn) {
          var sg = parseOptionGroups(adaptOptionsToGroups(s.options || []), isFr);
          sg.forEach(function (g, gi) {
            g.handle = 's' + sn + '-' + gi + '-' + (g.handle || slugify(g.name_en) || 'grp');
            g.sizeIndex = sn;
          });
          return sg;
        });
        // Combined set drives cartOptions init + price/summary lookups.
        var allGroups = groups.slice();
        perSizeGroups.forEach(function (sg) { sg.forEach(function (g) { allGroups.push(g); }); });
        if (allGroups.length > 0) itemOptionGroups[id] = allGroups;

        // Only item-level multi_qty drives the item's own quantity; per-size
        // options are radio and never do.
        var hasMultiQty = groups.some(function (g) { return g.type === 'multi_qty'; });

        // A radio group whose EN name is "Size" renders inline on featured
        // cards as always-visible price buttons (the choice label carries the
        // servings, e.g. "Serves 6–8"), replacing both the hidden drop-down
        // entry and the servings pill. Same cartOptions plumbing underneath.
        var sizeGroup = null;
        if (isFeatured) {
          for (var sgi = 0; sgi < groups.length; sgi++) {
            var sgKey = groups[sgi].handle || slugify(groups[sgi].name_en);
            if (groups[sgi].type === 'radio' && sgKey === 'size') { sizeGroup = groups[sgi]; break; }
          }
        }
        // Footer price mirrors the checked size (first choice by default).
        var displayPrice = sizeGroup
          ? price + (parseFloat(sizeGroup.choices[0].price_adj) || 0)
          : price;

        // The first featured platter card renders in the inverted green
        // "bubbie" treatment — same footprint as the rest, but colour-flipped
        // so the signature platter still leads the grid.
        var tagGreen = isFeatured && !greenTagged;
        if (tagGreen) greenTagged = true;
        html += '<div class="menu-item-wrap' + (tagGreen ? ' menu-item-wrap--green' : '') + '"' + (showImage ? ' data-has-image="1"' : '') + '>';
        html += '<div class="menu-item' + (showImage ? ' menu-item--has-photo' : '') + '" data-item-id="' + escAttr(id) + '" data-item-name="' + escAttr(name) + '" data-item-price="' + price.toFixed(2) + '"';
        if (minQty > 0) html += ' data-item-min="' + minQty + '"';
        if (hasMultiQty) html += ' data-multi-qty="1"';
        if (item.lead_time_hours != null) html += ' data-item-lead="' + item.lead_time_hours + '"';
        html += '>';

        // Photo (featured cards only) — clickable, wired to the enlarge modal
        // by initImageModal() via the data-full-src attribute.
        if (showImage) {
          html += '<div class="menu-item__image" data-full-src="' + escAttr(imageUrl) + '">';
          html += '<img src="' + escAttr(imageUrl) + '" alt="' + escAttr(name) + '" loading="lazy">';
          html += '</div>';
        }

        // Info
        html += '<div class="menu-item__info">';
        // Badge pill ("Most Popular", "Best Value") — featured cards only,
        // above the title row, mirroring the package badge treatment.
        if (isFeatured && badge) {
          html += '<div class="menu-item__badge">' + esc(badge) + '</div>';
        }
        // Title row — on featured cards the servings label rides next to the name.
        if (isFeatured) {
          html += '<div class="menu-item__title-row">';
          html += '<span class="menu-item__name">' + esc(name) + '</span>';
          // Size buttons carry their own servings labels — the pill would repeat them.
          if (servings && !sizeGroup) html += '<span class="menu-item__servings">' + esc(servings) + '</span>';
          html += '</div>';
        } else {
          html += '<span class="menu-item__name">' + esc(name) + '</span>';
        }
        // Lead paragraph (featured cards) — non-bulleted intro above the bullets.
        if (isFeatured && lead) {
          html += '<p class="menu-item__lead">' + esc(lead) + '</p>';
        }
        // Inline size buttons — real radio inputs (name matches the panel's
        // scheme) styled as segmented buttons showing absolute prices.
        if (sizeGroup) {
          html += '<div class="menu-item__sizes" data-sizes-for="' + escAttr(id) + '" role="radiogroup" aria-label="' + (isFr ? 'Format' : 'Size') + '">';
          sizeGroup.choices.forEach(function (c, ci) {
            html += '<label class="size-btn">';
            html += '<input type="radio" name="' + escAttr(id + '-size') + '" value="' + escAttr(c.key) + '" data-size-index="' + ci + '"' + (ci === 0 ? ' checked' : '') + '>';
            html += '<span class="size-btn__name">' + esc(c.name) + '</span>';
            html += '</label>';
          });
          html += '</div>';
        }
        // Contents: on featured cards prefer per-size structured contents (each
        // size may list different items); the buttons swap the list live. Fall
        // back to the flat multi-line description when a platter has no
        // structured contents yet (un-migrated) so nothing regresses. The
        // bullet list starts collapsed behind a "What's included" disclosure so
        // the card face stays short while browsing.
        var itemSizes = Array.isArray(item.sizes) ? item.sizes : [];
        var perSizeLines = isFeatured
          ? itemSizes.map(function (s) { return sizeContentLines(s, isFr); })
          : [];
        var hasSizeContents = perSizeLines.some(function (l) { return l.length; });
        var bulleted = desc && desc.indexOf('\n') !== -1;
        // The portion sold ("8oz"), kept out of the description so it can be
        // rendered in its own right. It comes BEFORE the description: one line
        // reading "8oz · (gf)" when the description is a phrase, its own line
        // above the bullets when the description is a list.
        var sizeText = item.size || '';
        var sizeHtml = sizeText
          ? '<span class="menu-item__size">' + esc(sizeText) + '</span>'
          : '';
        if (sizeHtml && (bulleted || (isFeatured && hasSizeContents))) {
          html += '<span class="menu-item__desc">' + sizeHtml + '</span>';
        }
        if (isFeatured && hasSizeContents) {
          // Stash all sizes' lines so the size-radio handler can swap them; the
          // default (cheapest = index 0, the checked size) renders now.
          sizeContentsByItem[id] = perSizeLines;
          var includedLabelS = isFr ? 'Ce qui est inclus' : "What's included";
          html += '<div class="menu-item__contents">';
          html += '<button type="button" class="menu-item__contents-toggle" aria-expanded="false">'
            + esc(includedLabelS) + ' <span class="menu-item__contents-caret">▾</span></button>';
          html += '<ul class="menu-item__desc menu-item__desc--list" data-size-contents-for="' + escAttr(id) + '">';
          perSizeLines[0].forEach(function (line) {
            html += '<li>' + esc(line) + '</li>';
          });
          html += '</ul>';
          html += '</div>';
        } else if (bulleted && isFeatured) {
          var includedLabel = isFr ? 'Ce qui est inclus' : "What's included";
          html += '<div class="menu-item__contents">';
          html += '<button type="button" class="menu-item__contents-toggle" aria-expanded="false">'
            + esc(includedLabel) + ' <span class="menu-item__contents-caret">▾</span></button>';
          html += '<ul class="menu-item__desc menu-item__desc--list">';
          desc.split('\n').forEach(function (line) {
            line = line.trim();
            if (line) html += '<li>' + esc(line) + '</li>';
          });
          html += '</ul>';
          html += '</div>';
        } else if (bulleted) {
          html += '<ul class="menu-item__desc menu-item__desc--list">';
          desc.split('\n').forEach(function (line) {
            line = line.trim();
            if (line) html += '<li>' + esc(line) + '</li>';
          });
          html += '</ul>';
        } else if (desc || sizeHtml) {
          html += '<span class="menu-item__desc">' + sizeHtml
            + (sizeHtml && desc ? '<span class="menu-item__sep"> · </span>' : '')
            + esc(desc) + '</span>';
        }
        if (minQty > 0) {
          html += '<span class="menu-item__min">min. ' + minQty + '</span>';
        }
        html += '</div>';

        // Right side: price + qty
        html += '<div class="menu-item__right">';
        html += '<span class="menu-item__price">$' + displayPrice.toFixed(2) + '</span>';
        if (!hasMultiQty) {
          // Standard qty control
          html += '<div class="qty-control" data-qty-item="' + escAttr(id) + '">';
          html += '<button class="qty-btn qty-minus" type="button" aria-label="Remove">−</button>';
          html += '<span class="qty-value">0</span>';
          html += '<button class="qty-btn qty-plus" type="button" aria-label="Add">+</button>';
          html += '</div>';
        } else {
          // "Make Selection(s)" button + total badge for multi_qty items
          var selectLabel = isFr ? 'Sélectionner' : 'Make Selection(s)';
          html += '<button class="menu-item__select-btn" data-select-for="' + escAttr(id) + '" type="button">' + selectLabel + '</button>';
          html += '<span class="menu-item__total-badge" data-total-for="' + escAttr(id) + '" style="display:none"></span>';
        }
        html += '</div></div>';

        // Option groups panel (starts hidden; toggled with item qty). The inline
        // size group is excluded (it renders as buttons above). Item-level
        // groups always show; per-size groups are wrapped by size and only the
        // active size's are visible (updateInlineSizeOptions swaps them).
        var itemPanelGroups = groups.filter(function (g) { return g !== sizeGroup; });
        var hasPerSizeOpts = perSizeGroups.some(function (sg) { return sg.length > 0; });
        if (itemPanelGroups.length > 0 || hasPerSizeOpts) {
          html += '<div class="menu-item__options" data-options-for="' + escAttr(id) + '" style="display:none">';
          itemPanelGroups.forEach(function (g) { html += optionGroupHtml(id, g); });
          perSizeGroups.forEach(function (sg, sn) {
            if (!sg.length) return;
            html += '<div class="oc-size-opts" data-opts-size-index="' + sn + '"' + (sn === 0 ? '' : ' style="display:none"') + '>';
            sg.forEach(function (g) { html += optionGroupHtml(id, g); });
            html += '</div>';
          });
          html += '</div>'; // menu-item__options
        }

        // Comment field (hidden by default)
        var commentPlaceholder = isFr ? 'Note pour cet article...' : 'Note for this item...';
        html += '<div class="menu-item__comment" data-comment-for="' + escAttr(id) + '" style="display:none">';
        html += '<input type="text" class="menu-item__comment-input" placeholder="' + escAttr(commentPlaceholder) + '">';
        html += '</div>';

        html += '</div>'; // menu-item-wrap
      });

      html += '</div></div>'; // menu-category__items, menu-category (or menu-addons-group)
    });
    if (addonsOpen) html += '</div>'; // menu-category--addons umbrella

    // Prepend the sticky section nav (only when 2+ sections exist — a single
    // tile is pointless). initSectionNav() wires up scroll-spy + smooth scroll.

    // Split a nav label into a first-word line + remainder line, each wrapped in
    // a span. On desktop the spans stay inline (with the space between → the
    // label reads on one line, unchanged); on mobile CSS blocks them so every
    // tile gets a consistent two-line label ("Bagel" / "Platters"), which keeps
    // the cramped narrow-screen tiles from running into each other. Single-word
    // labels stay on one line.
    function navLabelHtml(label) {
      var text = String(label == null ? '' : label).trim();
      var sp = text.indexOf(' ');
      if (sp === -1) return esc(text);
      return '<span class="oc-section-nav__lbl-line">' + esc(text.slice(0, sp)) +
        '</span> <span class="oc-section-nav__lbl-line">' + esc(text.slice(sp + 1).trim()) + '</span>';
    }

    var navHtml = '';
    if (sectionNav && navSections.length > 1) {
      navHtml += '<nav class="oc-section-nav" id="oc-section-nav" aria-label="Menu sections">';
      navSections.forEach(function (s) {
        navHtml += '<a class="oc-section-nav__item" href="#' + escAttr(s.id) +
          '" data-target="' + escAttr(s.id) + '">';
        navHtml += '<span class="oc-section-nav__img-wrap">';
        if (s.imageUrl) {
          navHtml += '<img src="' + escAttr(s.imageUrl) + '" alt="" loading="lazy">';
        } else {
          navHtml += '<span class="oc-section-nav__mono">' + esc((s.label || '?').charAt(0)) + '</span>';
        }
        navHtml += '</span>';
        navHtml += '<span class="oc-section-nav__label">' + navLabelHtml(s.label) + '</span>';
        navHtml += '</a>';
      });
      navHtml += '</nav>';
    }

    menuEl.innerHTML = navHtml + html;

    // Attach category collapse toggles
    menuEl.querySelectorAll('.menu-category__title').forEach(function (title) {
      title.addEventListener('click', function () {
        var cat = title.parentElement;
        var isOpen = !cat.classList.contains('collapsed');
        // Close all collapsible categories (skip flat and featured — they
        // have no toggle and stay open).
        menuEl.querySelectorAll('.menu-category:not(.menu-category--flat):not(.menu-category--featured)').forEach(function (c) {
          c.classList.add('collapsed');
        });
        // If it was closed, open it
        if (!isOpen) {
          cat.classList.remove('collapsed');
        }
      });
    });

    // Inline size selectors (featured cards): push the pick into cartOptions
    // and reprice the footer. These radios live outside the options panel, so
    // the generic panel radio handler never sees them.
    menuEl.querySelectorAll('.menu-item__sizes').forEach(function (sizesEl) {
      var sizeItemId = sizesEl.dataset.sizesFor;
      sizesEl.querySelectorAll('input[type="radio"]').forEach(function (radio) {
        radio.addEventListener('change', function () {
          initCartOptions(sizeItemId);
          if (!cartOptions[sizeItemId]) cartOptions[sizeItemId] = {};
          if (!cartOptions[sizeItemId].size) cartOptions[sizeItemId].size = { type: 'radio', selected: radio.value };
          cartOptions[sizeItemId].size.selected = radio.value;
          var sIdx = parseInt(radio.dataset.sizeIndex, 10) || 0;
          activeSizeIndexByItem[sizeItemId] = sIdx;
          updateInlineSizePrice(sizeItemId);
          updateInlineSizeContents(sizeItemId, sIdx);
          updateInlineSizeOptions(sizeItemId, sIdx);
          renderSummary();
        });
      });
    });

    // Platter "What's included" disclosures (featured cards).
    menuEl.querySelectorAll('.menu-item__contents-toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var wrap = btn.closest('.menu-item__contents');
        if (!wrap) return;
        var open = wrap.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    // Package contents: capped height + internal scroll by default. Measure
    // each list now that it's in the document — hide the "Show all" toggle
    // when everything already fits, and mark overflowing lists so CSS can
    // add the scroll affordance (bottom fade).
    menuEl.querySelectorAll('.menu-package').forEach(function (pkgEl) {
      var ul = pkgEl.querySelector('.menu-package__contents');
      var btn = pkgEl.querySelector('.menu-package__more');
      if (!ul) return;
      var overflows = ul.scrollHeight > ul.clientHeight + 1;
      if (overflows) {
        ul.classList.add('menu-package__contents--scrollable');
        var well = ul.closest('.menu-package__contents-well');
        if (well) well.classList.add('menu-package__contents-well--scrollable');
      }
      else if (btn) btn.style.display = 'none';
    });

    // "Show all" / "Show less" — expands the height cap away and back.
    menuEl.querySelectorAll('.menu-package__more').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pkgEl = btn.closest('.menu-package');
        if (!pkgEl) return;
        var expanded = pkgEl.classList.toggle('menu-package--expanded');
        btn.textContent = expanded
          ? (btn.getAttribute('data-less') || 'Show less')
          : (btn.getAttribute('data-more') || 'Show all');
      });
    });

    refreshPackageParallax(menuEl);
  }

  // ─── Package contents parallax ─────────────────────────────────────────
  // As the page scrolls a capped contents list through the viewport, drift
  // its internal scroll a few lines — a passer-by sees the list move inside
  // its box and learns it scrolls, without reading the fade or scrollbar.
  // Deliberately conservative: a list stops drifting forever the moment the
  // user touches it (their scroll position is theirs), expanded cards are
  // exempt (no cap to hint at), and prefers-reduced-motion turns the whole
  // thing off. Re-renders (locale switch) refresh the element list; the one
  // window scroll listener is bound once.
  var parallaxLists = [];
  var parallaxBound = false;
  var PARALLAX_DRIFT = 250; // max px of internal travel over a full pass
  // The drift only begins once the list's top has risen to START × viewport
  // height, so a reader always meets the list at its real top — and reaches
  // full drift by END × viewport height. Between the two it's linear.
  var PARALLAX_START = 0.5;
  var PARALLAX_END = 0;

  function updatePackageParallax() {
    var vh = window.innerHeight || 1;
    parallaxLists.forEach(function (ul) {
      if (ul.dataset.ocEngaged === '1') return;
      var pkgEl = ul.closest('.menu-package');
      if (!pkgEl || pkgEl.classList.contains('menu-package--expanded')) return;
      var rect = ul.getBoundingClientRect();
      if (rect.bottom <= 0 || rect.top >= vh) return;
      var range = ul.scrollHeight - ul.clientHeight;
      if (range <= 0) return;
      // 0 until the top reaches PARALLAX_START of the viewport (the list
      // rests at its own top while first seen), then 0 → 1 by PARALLAX_END.
      var startY = vh * PARALLAX_START;
      var endY = vh * PARALLAX_END;
      var progress = (startY - rect.top) / (startY - endY);
      progress = Math.max(0, Math.min(1, progress));
      ul.scrollTop = Math.min(range, PARALLAX_DRIFT) * progress;
    });
  }

  function refreshPackageParallax(menuEl) {
    if (window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    parallaxLists = Array.prototype.slice.call(
      menuEl.querySelectorAll('.menu-package__contents--scrollable')
    );
    // A fresh render means fresh elements — attach the "the user took over"
    // markers to each. Scrollbar drags land as pointerdown on the list.
    parallaxLists.forEach(function (ul) {
      ['wheel', 'touchstart', 'pointerdown'].forEach(function (ev) {
        ul.addEventListener(ev, function () { ul.dataset.ocEngaged = '1'; }, { passive: true });
      });
    });
    if (!parallaxBound && parallaxLists.length > 0) {
      parallaxBound = true;
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          updatePackageParallax();
        });
      }, { passive: true });
    }
    updatePackageParallax();
  }

  // ─── Option group helpers ──────────────────────────────────────────────

  function parseOptionGroups(raw, isFr) {
    if (!raw || !Array.isArray(raw) || raw.length === 0) return [];
    return raw.map(function (og) {
      var choices = [];
      try {
        var parsed = typeof og.choices_json === 'string' ? JSON.parse(og.choices_json) : og.choices_json;
        if (Array.isArray(parsed)) {
          choices = parsed.map(function (c) {
            return {
              key: slugify(c.name_en || ''),
              name: (isFr && c.name_fr) ? c.name_fr : (c.name_en || ''),
              name_en: c.name_en || '',
              price_adj: parseFloat(c.price_adj) || 0,
            };
          });
        }
      } catch (e) { /* ignore bad JSON */ }
      return {
        handle: og.handle || '',
        name: (isFr && og.name_fr) ? og.name_fr : (og.name_en || ''),
        name_en: og.name_en || '',
        type: (og.selection_type || og.type) === 'multi_qty' ? 'multi_qty' : 'radio',
        required: og.required === true || og.required === 'true',
        choices: choices,
      };
    }).filter(function (g) { return g.choices.length > 0; });
  }

  function esc(str) {
    var d = document.createElement('div');
    d.textContent = str;
    return d.innerHTML;
  }

  function escAttr(str) {
    return String(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  // ─── State ────────────────────────────────────────────────────────────────

  var cart = {};       // { itemId: qty }
  var cartOptions = {} // { itemId: { groupHandle: { type, selected/selections } } }
  var cartPackageOptions = {}; // { 'pkg-handle': { itemHandle: { groupHandle: {type, selected/selections} } } }
  var cartPackageExtras = {};  // { 'pkg-handle': { itemHandle: count } } — suggested add-on picks (109), charged à la carte
  var itemComments = {};
  var paymentMethod = 'in_person';
  // Toggled by the admin (app_settings.allow_online_payment, surfaced via
  // /api/menu). When false, the online/PayPal path is hidden entirely and the
  // customer is directed to pay in person at pickup.
  var onlinePaymentEnabled = true;

  // Package lookup by handle, populated in renderMenu so click handlers can
  // resolve a package (and its item option groups) from the qty-control id.
  var pkgByHandle = {};

  function initCartOptions(itemId) {
    if (cartOptions[itemId]) return;
    var groups = itemOptionGroups[itemId];
    if (!groups || groups.length === 0) return;
    cartOptions[itemId] = {};
    groups.forEach(function (g) {
      var key = g.handle || slugify(g.name_en);
      if (g.type === 'radio') {
        cartOptions[itemId][key] = { type: 'radio', selected: g.choices[0].key };
      } else {
        var sels = {};
        g.choices.forEach(function (c) { sels[c.key] = 0; });
        cartOptions[itemId][key] = { type: 'multi_qty', selections: sels };
      }
    });
  }

  function getItemOptionsSummary(itemId) {
    var opts = cartOptions[itemId];
    var groups = itemOptionGroups[itemId];
    if (!opts || !groups) return [];
    var activeSize = activeSizeIndexByItem[itemId] || 0;
    return groups.map(function (g) {
      // Size-scoped groups only count for the selected size.
      if (g.sizeIndex != null && g.sizeIndex !== activeSize) return null;
      var key = g.handle || slugify(g.name_en);
      var data = opts[key];
      if (!data) return null;
      if (data.type === 'radio') {
        var choice = g.choices.find(function (c) { return c.key === data.selected; });
        return { group: g.name, group_en: g.name_en, type: 'radio', selected: data.selected, selectedName: choice ? choice.name : data.selected };
      } else {
        var active = {};
        Object.keys(data.selections).forEach(function (k) {
          if (data.selections[k] > 0) active[k] = data.selections[k];
        });
        // Map keys to display names
        var namedSelections = {};
        Object.keys(active).forEach(function (k) {
          var choice = g.choices.find(function (c) { return c.key === k; });
          var displayName = choice ? choice.name : k;
          namedSelections[displayName] = active[k];
        });
        return { group: g.name, group_en: g.name_en, type: 'multi_qty', selections: active, namedSelections: namedSelections };
      }
    }).filter(Boolean);
  }

  // ── Inline size selector helpers ──
  // The visible size radios live on the card face, outside the options panel,
  // so the panel's qty-0 reset (delete cartOptions + reset panel radios) never
  // touches them. Re-syncing state from the checked DOM radio whenever qty
  // rises keeps what the customer sees authoritative.
  function syncInlineSizeSelection(itemId) {
    var sizesEl = root.querySelector('[data-sizes-for="' + itemId + '"]');
    if (!sizesEl) return;
    var checked = sizesEl.querySelector('input[type="radio"]:checked');
    if (!checked) return;
    if (!cartOptions[itemId]) cartOptions[itemId] = {};
    if (!cartOptions[itemId].size) cartOptions[itemId].size = { type: 'radio', selected: checked.value };
    cartOptions[itemId].size.selected = checked.value;
  }

  // Footer price = base + the checked size's adjustment.
  function updateInlineSizePrice(itemId) {
    var sizesEl = root.querySelector('[data-sizes-for="' + itemId + '"]');
    var itemEl = root.querySelector('.menu-item[data-item-id="' + itemId + '"]');
    if (!sizesEl || !itemEl) return;
    var priceEl = itemEl.querySelector('.menu-item__price');
    if (!priceEl) return;
    var checked = sizesEl.querySelector('input[type="radio"]:checked');
    var adj = 0;
    var groups = itemOptionGroups[itemId] || [];
    for (var gi = 0; gi < groups.length; gi++) {
      var key = groups[gi].handle || slugify(groups[gi].name_en);
      if (key !== 'size') continue;
      var choice = checked && groups[gi].choices.find(function (c) { return c.key === checked.value; });
      if (choice) adj = parseFloat(choice.price_adj) || 0;
      break;
    }
    var base = parseFloat(itemEl.dataset.itemPrice) || 0;
    priceEl.textContent = fmt(base + adj);
  }

  // Swap the "What's included" list to the selected size's contents. No-op when
  // the item has no structured per-size contents (description-fallback items).
  function updateInlineSizeContents(itemId, sizeIndex) {
    var lists = sizeContentsByItem[itemId];
    if (!lists) return;
    var listEl = root.querySelector('[data-size-contents-for="' + itemId + '"]');
    if (!listEl) return;
    var lines = lists[sizeIndex] || lists[0] || [];
    var html = '';
    lines.forEach(function (line) { html += '<li>' + esc(line) + '</li>'; });
    listEl.innerHTML = html;
  }

  // Show only the selected size's option groups in the panel (schmears etc.).
  // No-op for items without per-size options.
  function updateInlineSizeOptions(itemId, sizeIndex) {
    var panel = root.querySelector('[data-options-for="' + itemId + '"]');
    if (!panel) return;
    panel.querySelectorAll('.oc-size-opts').forEach(function (el) {
      el.style.display = (parseInt(el.dataset.optsSizeIndex, 10) === sizeIndex) ? '' : 'none';
    });
  }

  function getOptionsPriceAdj(itemId) {
    var opts = cartOptions[itemId];
    var groups = itemOptionGroups[itemId];
    if (!opts || !groups) return 0;
    var activeSize = activeSizeIndexByItem[itemId] || 0;
    var adj = 0;
    groups.forEach(function (g) {
      // Size-scoped groups only price for the selected size.
      if (g.sizeIndex != null && g.sizeIndex !== activeSize) return;
      var key = g.handle || slugify(g.name_en);
      var data = opts[key];
      if (!data) return;
      if (data.type === 'radio') {
        var choice = g.choices.find(function (c) { return c.key === data.selected; });
        if (choice) adj += choice.price_adj;
      } else {
        Object.keys(data.selections).forEach(function (k) {
          var subQty = data.selections[k];
          if (subQty > 0) {
            var choice = g.choices.find(function (c) { return c.key === k; });
            if (choice) adj += choice.price_adj * subQty;
          }
        });
      }
    });
    return adj;
  }

  // Total upcharge (across all units) from a configured package's option
  // selections. Package picks live in cartPackageOptions — set by the config
  // modal and keyed separately from standalone-item cartOptions — so the
  // regular getOptionsPriceAdj() never sees them. multi_qty selection counts
  // are already absolute (they sum to item.quantity × package qty) so they're
  // summed as-is; a radio choice applies to every unit, so it's scaled by the
  // item's per-package quantity and the number of packages.
  function getPackageOptionsPriceAdj(pkgId, pkgQty) {
    var picks = cartPackageOptions[pkgId];
    if (!picks) return 0;
    var pkg = pkgByHandle[pkgId.replace(/^pkg-/, '')];
    if (!pkg || !pkg.items) return 0;
    var qty = Math.max(1, pkgQty || 1);
    var adj = 0;
    pkg.items.forEach(function (pi) {
      var itemPicks = picks[pi.id];
      if (!itemPicks || !pi.option_groups) return;
      pi.option_groups.forEach(function (g) {
        var key = g.handle || slugify(g.name_en);
        var data = itemPicks[key];
        if (!data) return;
        var choices = [];
        try { choices = JSON.parse(g.choices_json || '[]'); } catch (_) { choices = []; }
        var adjByKey = {};
        choices.forEach(function (c) {
          adjByKey[slugify(c.name_en)] = parseFloat(c.price_adj) || 0;
        });
        if (data.type === 'radio') {
          adj += (adjByKey[data.selected] || 0) * pi.quantity * qty;
        } else if (data.selections) {
          var sum = 0;
          Object.keys(data.selections).forEach(function (k) {
            adj += (adjByKey[k] || 0) * (data.selections[k] || 0);
            sum += data.selections[k] || 0;
          });
          // Picks beyond the included count are charged at the item's
          // à-la-carte unit price (109) — the per-choice adj above already
          // covered every unit, included or not.
          var extraN = Math.max(0, sum - pi.quantity * qty);
          if (extraN > 0) adj += extraN * (pi.price || 0);
        }
      });
    });
    return adj;
  }

  // ─── Helpers ─────────────────────────────────────────────────────────────

  function fmt(price) {
    return '$' + price.toFixed(2);
  }

  // A cart line's full price: base × qty plus any package customization
  // upcharge (standalone-item option costs are already folded into i.price).
  function lineTotal(i) {
    return i.qty * i.price + (i.optionAdj || 0);
  }

  function getCartItems() {
    var items = [];
    Object.keys(cart).forEach(function (id) {
      var qty = cart[id];
      if (qty > 0 && menuItems[id]) {
        var isPkg = id.indexOf('pkg-') === 0;
        var priceAdj = getOptionsPriceAdj(id);
        var effectivePrice = menuItems[id].price + priceAdj;
        items.push({
          id: id,
          name: menuItems[id].name,
          qty: qty,
          price: effectivePrice,
          basePrice: menuItems[id].price,
          optionAdj: isPkg ? getPackageOptionsPriceAdj(id, qty) : 0,
          comment: itemComments[id] || '',
          options: getItemOptionsSummary(id),
        });
        // Suggested add-on picks (109) become their own priced lines right
        // under the package — real items at à-la-carte price, so the
        // summary, taxes and the submitted order all see them plainly.
        if (isPkg && cartPackageExtras[id]) {
          var pkgObj = pkgByHandle[id.replace(/^pkg-/, '')];
          var isFr = CONFIG.locale === 'fr';
          ((pkgObj && pkgObj.items) || []).forEach(function (pi) {
            var n = cartPackageExtras[id][pi.id] || 0;
            if (n <= 0 || !pi.suggested || !(pi.price > 0)) return;
            var piName = (isFr && pi.name_fr) ? pi.name_fr : pi.name_en;
            items.push({
              id: pi.id,
              name: piName,
              qty: n,
              price: pi.price || 0,
              basePrice: pi.price || 0,
              optionAdj: 0,
              comment: (isFr ? 'Ajouté avec ' : 'Added with ') + menuItems[id].name,
              options: [],
            });
          });
        }
      }
    });
    return items;
  }

  function getCartTotal() {
    return getCartItems().reduce(function (sum, i) { return sum + lineTotal(i); }, 0);
  }

  var TAX_RATES = { GST: 0.05, QST: 0.09975 };

  function getTaxes(subtotal) {
    return {
      gst: subtotal * TAX_RATES.GST,
      qst: subtotal * TAX_RATES.QST,
    };
  }

  function getGrandTotal() {
    var subtotal = getCartTotal();
    var taxes = getTaxes(subtotal);
    return subtotal + taxes.gst + taxes.qst;
  }

  function val(id) {
    var el = document.getElementById(id);
    return el ? el.value : '';
  }

  function isFormValid() {
    var name   = val('oc-name').trim();
    var email  = val('oc-email').trim();
    var phone  = val('oc-phone').trim();
    var pickup = val('oc-pickup');
    if (!(name && /\S+@\S+\.\S+/.test(email) && phone && pickup)) return false;
    // Block submission if any cart item needs more notice than the picked
    // pickup time allows.
    return getPickupLeadShortfallHours() <= 0;
  }

  // Max lead time required by anything currently in the cart. Each item
  // declares its own lead_time_hours; if absent we fall back to the page's
  // default buffer (pickup.buffer_hours from /api/menu, default 48h).
  function getMaxRequiredLeadHours() {
    var max = 0;
    var ids = Object.keys(cart);
    for (var i = 0; i < ids.length; i++) {
      var id = ids[i];
      if (cart[id] <= 0 || !menuItems[id]) continue;
      var hrs = menuItems[id].leadHours != null
        ? menuItems[id].leadHours
        : pageBufferHours;
      if (hrs > max) max = hrs;
    }
    return max;
  }

  // Positive number = required lead exceeds time-until-pickup by that many
  // hours (warning state). 0 or negative = OK. Returns 0 when pickup or cart
  // is empty so the warning never shows in pre-submit states.
  function getPickupLeadShortfallHours() {
    var pickupIso = val('oc-pickup');
    if (!pickupIso) return 0;
    if (Object.keys(cart).length === 0) return 0;
    var pickupDate = new Date(pickupIso);
    if (isNaN(pickupDate.getTime())) return 0;
    var hoursUntil = (pickupDate.getTime() - Date.now()) / 36e5;
    var required = getMaxRequiredLeadHours();
    var shortfall = required - hoursUntil;
    return shortfall > 0 ? shortfall : 0;
  }

  function updateLeadTimeWarning() {
    var warn = document.getElementById('oc-pickup-warning');
    if (!warn) return;
    var shortfall = getPickupLeadShortfallHours();
    if (shortfall <= 0) {
      warn.style.display = 'none';
      warn.textContent = '';
      return;
    }
    var required = getMaxRequiredLeadHours();
    var isFr = CONFIG.locale === 'fr';
    warn.textContent = isFr
      ? 'Un ou plusieurs articles de votre panier nécessitent au moins '
        + required + ' h d’avance. Veuillez choisir une heure de ramassage plus tardive.'
      : 'One or more items in your cart need at least '
        + required + ' hours advance notice. Please pick a later pickup time.';
    warn.style.display = 'block';
  }

  // ─── Option formatting helpers ─────────────────────────────────────────────

  function formatOptionsSummaryHtml(options) {
    if (!options || options.length === 0) return '';
    return '<div class="order-line-options">' + options.map(function (o) {
      if (o.type === 'radio') {
        return '<span class="order-line-opt">' + esc(o.group) + ': ' + esc(o.selectedName) + '</span>';
      } else {
        var parts = [];
        Object.keys(o.namedSelections).forEach(function (name) {
          parts.push(o.namedSelections[name] + ' ' + name);
        });
        return parts.length > 0 ? '<span class="order-line-opt">' + esc(o.group) + ': ' + esc(parts.join(', ')) + '</span>' : '';
      }
    }).filter(Boolean).join('') + '</div>';
  }

  function formatOptionsText(options) {
    if (!options || options.length === 0) return '';
    return options.map(function (o) {
      if (o.type === 'radio') {
        return o.group + ': ' + o.selectedName;
      } else {
        var parts = [];
        Object.keys(o.namedSelections).forEach(function (name) {
          parts.push(o.namedSelections[name] + ' ' + name);
        });
        return parts.length > 0 ? o.group + ': ' + parts.join(', ') : '';
      }
    }).filter(Boolean).join(' | ');
  }

  // Flatten a configured package's customizations into display rows, resolving
  // each selection back to its choice name and price_adj. Mirrors the pricing
  // in getPackageOptionsPriceAdj so the summary and the total stay in step.
  function getPackageOptionLines(pkgId) {
    var picks = cartPackageOptions[pkgId];
    var pkg = pkgByHandle[pkgId.replace(/^pkg-/, '')];
    if (!picks || !pkg || !pkg.items) return [];
    var isFr = CONFIG.locale === 'fr';
    var out = [];
    pkg.items.forEach(function (pi) {
      var itemPicks = picks[pi.id];
      if (!itemPicks || !pi.option_groups) return;
      var piName = (isFr && pi.name_fr) ? pi.name_fr : pi.name_en;
      pi.option_groups.forEach(function (g) {
        var key = g.handle || slugify(g.name_en);
        var data = itemPicks[key];
        if (!data) return;
        var groupName = (isFr && g.name_fr) ? g.name_fr : g.name_en;
        var choices = [];
        try { choices = JSON.parse(g.choices_json || '[]'); } catch (_) { choices = []; }
        var byKey = {};
        choices.forEach(function (c) {
          byKey[slugify(c.name_en)] = {
            name: (isFr && c.name_fr) ? c.name_fr : c.name_en,
            adj:  parseFloat(c.price_adj) || 0,
          };
        });
        var entries = [];
        if (data.type === 'radio') {
          var rc = byKey[data.selected];
          if (rc) entries.push({ name: rc.name, count: 1, adj: rc.adj });
        } else if (data.selections) {
          Object.keys(data.selections).forEach(function (k) {
            var n = data.selections[k] || 0;
            if (n > 0 && byKey[k]) entries.push({ name: byKey[k].name, count: n, adj: byKey[k].adj });
          });
        }
        if (entries.length > 0) out.push({ item: piName, group: groupName, entries: entries });
        // Over-target picks: surface the à-la-carte charge as its own line
        // so the upcharge in the total is visibly accounted for. Only with
        // a known price — an unpriced extra is capped out of existence
        // upstream, and a "+$0.00" line would misstate it anyway.
        if (data.type === 'multi_qty' && data.selections && pi.price > 0) {
          var sum = 0;
          Object.keys(data.selections).forEach(function (k) { sum += data.selections[k] || 0; });
          var pkgQty = Math.max(1, cart[pkgId] || 1);
          var extraN = sum - pi.quantity * pkgQty;
          if (extraN > 0) {
            out.push({
              item: piName,
              group: isFr ? 'En sus' : 'Extra',
              entries: [{ name: isFr ? 'à la carte' : 'à la carte', count: extraN, adj: pi.price || 0 }],
            });
          }
        }
      });
    });
    return out;
  }

  function packageOptionEntryText(e) {
    var txt = (e.count > 1 ? e.count + ' × ' : '') + e.name;
    if (e.adj > 0) txt += ' (+' + fmt(e.adj * e.count) + ')';
    return txt;
  }

  function formatPackageOptionsSummaryHtml(pkgId) {
    var lines = getPackageOptionLines(pkgId);
    if (lines.length === 0) return '';
    return lines.map(function (l) {
      var names = l.entries.map(function (e) {
        return (e.count > 1 ? e.count + ' × ' : '') + e.name;
      });
      var lineAdj = l.entries.reduce(function (s, e) { return s + e.adj * e.count; }, 0);
      var label = l.item + ' — ' + l.group + ': ' + names.join(', ');
      var right = lineAdj > 0 ? '+' + fmt(lineAdj) : '';
      return '<div class="order-line-cust"><span>' + esc(label) + '</span><span>' + esc(right) + '</span></div>';
    }).join('');
  }

  function formatPackageOptionsText(pkgId) {
    var lines = getPackageOptionLines(pkgId);
    if (lines.length === 0) return '';
    return lines.map(function (l) {
      return l.item + ' — ' + l.group + ': ' + l.entries.map(packageOptionEntryText).join(', ');
    }).join('\n   ▸ ');
  }

  // ─── Render order summary ─────────────────────────────────────────────────

  function renderSummary() {
    var listEl  = document.getElementById('oc-order-items');
    var totalEl = document.getElementById('oc-order-total');
    if (!listEl || !totalEl) return;

    var items      = getCartItems();
    var subtotal   = getCartTotal();
    var taxes      = getTaxes(subtotal);
    var total      = subtotal + taxes.gst + taxes.qst;
    var emptyMsg   = CONFIG.locale === 'fr' ? 'Aucun article sélectionné' : 'No items selected';

    listEl.innerHTML = items.length === 0
      ? '<p class="order-empty">' + emptyMsg + '</p>'
      : items.map(function (i) {
          var line = '<div class="order-line"><span>' + i.qty + ' × ' + i.name + '</span><span>' + fmt(i.qty * i.price) + '</span></div>';
          if (i.id.indexOf('pkg-') === 0) {
            line += formatPackageOptionsSummaryHtml(i.id);
          }
          if (i.options && i.options.length > 0) {
            line += formatOptionsSummaryHtml(i.options);
          }
          if (i.comment) {
            line += '<div class="order-line-comment">' + i.comment.replace(/</g, '&lt;') + '</div>';
          }
          return line;
        }).join('');

    var set = function (id, v) { var el = document.getElementById(id); if (el) el.textContent = v; };
    set('oc-subtotal',     fmt(subtotal));
    set('oc-gst',          fmt(taxes.gst));
    set('oc-qst',          fmt(taxes.qst));
    set('oc-order-total',  fmt(total));
    set('oc-sticky-total', fmt(total));

    updateLeadTimeWarning();
    updatePaymentZone();
  }

  // ─── Payment zone ─────────────────────────────────────────────────────────

  // Apply the admin's online-payment setting. When disabled we hide the whole
  // payment-method chooser (so PayPal is never mentioned), pin the method to
  // in-person, and surface a "pay at pickup" note instead.
  function applyPaymentConfig(enabled) {
    onlinePaymentEnabled = enabled !== false;
    var selector = document.getElementById('oc-payment-method-selector');
    var note     = document.getElementById('oc-inperson-note');
    if (onlinePaymentEnabled) {
      if (selector) selector.style.display = '';
      if (note)     note.style.display     = 'none';
      return;
    }
    paymentMethod = 'in_person';
    var inPersonRadio = document.querySelector('input[name="oc-payment-method"][value="in_person"]');
    if (inPersonRadio) inPersonRadio.checked = true;
    if (selector) selector.style.display = 'none';
    if (note)     note.style.display     = 'block';
    renderSummary();
  }

  function updatePaymentZone() {
    var hasItems  = getGrandTotal() > 0;
    var formReady = isFormValid();
    var ready     = hasItems && formReady;

    var continueBtn      = document.getElementById('oc-continue-btn');
    var continueDisabled = document.getElementById('oc-continue-disabled');
    if (continueBtn)      continueBtn.style.display      = hasItems ? 'block' : 'none';
    if (continueDisabled) continueDisabled.style.display = hasItems ? 'none'  : 'block';

    var stickyContinue = document.getElementById('oc-sticky-continue');
    var stickyDisabled = document.getElementById('oc-sticky-disabled');
    if (stickyContinue) stickyContinue.style.display = hasItems ? 'block' : 'none';
    if (stickyDisabled) stickyDisabled.style.display = hasItems ? 'none'  : 'block';

    var disabledEl        = document.getElementById('oc-paypal-disabled');
    var inpersonContainer = document.getElementById('oc-inperson-container');
    var onlineContainer   = document.getElementById('oc-online-container');

    if (!ready) {
      if (disabledEl)        disabledEl.style.display        = 'block';
      if (inpersonContainer) inpersonContainer.style.display = 'none';
      if (onlineContainer)   onlineContainer.style.display   = 'none';
    } else if (paymentMethod === 'online') {
      if (disabledEl)        disabledEl.style.display        = 'none';
      if (inpersonContainer) inpersonContainer.style.display = 'none';
      if (onlineContainer)   onlineContainer.style.display   = 'block';
    } else {
      if (disabledEl)        disabledEl.style.display        = 'none';
      if (onlineContainer)   onlineContainer.style.display   = 'none';
      if (inpersonContainer) inpersonContainer.style.display = 'block';
    }
  }

  // ─── Conversion tracking ───────────────────────────────────────────────────

  // Reports a placed order to GA4 (and GTM, if present) so Google Ads can
  // optimise toward real catering orders. The theme loads gtag site-wide when
  // a GA4 Measurement ID is set in theme settings (Google Analytics); this is
  // a harmless no-op when it isn't. Beacon transport so the event survives the
  // immediate redirect to the Shopify invoice on the online-payment path.
  function trackOrderConversion(total) {
    var value = Math.round(total * 100) / 100;
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'catering_order', {
          currency: CONFIG.currency,
          value: value,
          transport_type: 'beacon',
        });
      }
    } catch (_) {}
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'catering_order', currency: CONFIG.currency, value: value });
    } catch (_) {}
  }

  // ─── Checkout submit ───────────────────────────────────────────────────────

  // Shared submit for both payment methods. Saves the order via /api/checkout;
  // for online it redirects to the Shopify-hosted invoice, for in person it
  // shows the success screen (the order is an unpaid Shopify draft staff collect
  // at pickup). If online can't produce an invoice (Shopify not configured), it
  // degrades to the pay-at-pickup confirmation rather than losing the order.
  function runCheckout(paymentStatus, btn) {
    if (!isFormValid() || getGrandTotal() === 0) {
      highlightErrors();
      return;
    }
    if (!validateMinQty()) return;

    var original = btn ? btn.textContent : '';
    if (btn) {
      btn.disabled = true;
      btn.textContent = CONFIG.locale === 'fr' ? 'Envoi en cours…' : 'Submitting…';
    }

    submitOrderToAdmin({ paymentStatus: paymentStatus }).then(function (res) {
      // The order is saved in the admin at this point on both payment paths,
      // so this is the conversion moment (online payment itself happens later
      // on the Shopify-hosted invoice).
      trackOrderConversion(getGrandTotal());
      if (paymentStatus === 'online' && res && res.invoiceUrl) {
        window.location.href = res.invoiceUrl;
        return;
      }
      var orderId = (res && res.order_number) || generateOrderId();
      sendEmails({ paymentStatus: 'in_person', orderId: orderId });
      showSuccess({ paymentStatus: 'in_person', orderId: orderId });
    }).catch(function (err) {
      console.error('Checkout failed:', err);
      if (btn) {
        btn.disabled = false;
        btn.textContent = original;
      }
      alert(CONFIG.locale === 'fr'
        ? 'Une erreur est survenue. Veuillez réessayer.'
        : 'An error occurred. Please try again.');
    });
  }

  // ─── EmailJS ──────────────────────────────────────────────────────────────

  function sendEmails(opts) {
    var txnId = opts.txnId || '—';
    var paymentStatus = opts.paymentStatus || 'in_person';
    var orderId = opts.orderId || '';

    if (!window.emailjs || !CONFIG.emailjsPublicKey || !CONFIG.emailjsServiceId) return;
    emailjs.init(CONFIG.emailjsPublicKey);

    var name   = val('oc-name').trim();
    var email  = val('oc-email').trim();
    var phone  = val('oc-phone').trim();
    var pickup = val('oc-pickup');
    var notes  = val('oc-notes').trim();
    var items  = getCartItems();

    var subtotal   = getCartTotal();
    var taxes      = getTaxes(subtotal);
    var total      = subtotal + taxes.gst + taxes.qst;

    var orderLines = items.map(function (i) {
      var line = i.qty + 'x ' + i.name + ' — ' + fmt(i.qty * i.price);
      if (i.id.indexOf('pkg-') === 0) {
        var pkgOptText = formatPackageOptionsText(i.id);
        if (pkgOptText) line += '\n   ▸ ' + pkgOptText;
      }
      var optText = formatOptionsText(i.options);
      if (optText) line += '\n   ▸ ' + optText;
      if (i.comment) line += '\n   → ' + i.comment;
      return line;
    }).join('\n');

    var paymentLabel = paymentStatus === 'online'
      ? (CONFIG.locale === 'fr' ? 'Payé en ligne (carte)' : 'Paid online (card)')
      : (CONFIG.locale === 'fr' ? 'Paiement à la livraison' : 'Pay on pickup');

    var sharedFields = {
      order_id:          orderId,
      order_subtotal:    fmt(subtotal),
      order_gst:         fmt(taxes.gst),
      order_qst:         fmt(taxes.qst),
      order_service_fee: '—',
      order_total:       fmt(total),
      payment_status:    paymentLabel,
      transaction_id:    paymentStatus === 'online' ? txnId : '—',
    };

    var logErr = function (label, err) {
      console.error('EmailJS ' + label + ' send failed:', err);
    };

    if (CONFIG.emailjsCustomerTemplate) {
      emailjs.send(CONFIG.emailjsServiceId, CONFIG.emailjsCustomerTemplate, Object.assign({
        to_name:         name,
        to_email:        email,
        order_items:     orderLines,
        pickup_datetime: pickup,
        notes:           notes || '—',
      }, sharedFields)).catch(function (err) { logErr('customer', err); });
    }

    if (CONFIG.emailjsRestaurantTemplate) {
      emailjs.send(CONFIG.emailjsServiceId, CONFIG.emailjsRestaurantTemplate, Object.assign({
        customer_name:   name,
        customer_email:  email,
        customer_phone:  phone,
        order_items:     orderLines,
        pickup_datetime: pickup,
        notes:           notes || '—',
      }, sharedFields)).catch(function (err) { logErr('restaurant', err); });
    }
  }

  // ─── Admin API ───────────────────────────────────────────────────────────

  // POST the order to the admin app's /api/checkout. The route saves it and,
  // for online payment, creates a Shopify draft order. Resolves to the parsed
  // response { order_id, order_number, invoiceUrl } (invoiceUrl null for
  // in-person or when Shopify isn't configured). Payment stays "pending" here;
  // online orders flip to "paid" via the Shopify orders/paid webhook.
  function submitOrderToAdmin(opts) {
    var paymentStatus = opts.paymentStatus || 'in_person';

    if (!ADMIN_CHECKOUT_URL) {
      return Promise.reject(new Error('Checkout not configured'));
    }

    var name   = val('oc-name').trim();
    var email  = val('oc-email').trim();
    var phone  = val('oc-phone').trim();
    var pickup = val('oc-pickup');
    var notes  = val('oc-notes').trim();
    var items  = getCartItems();

    var subtotal   = getCartTotal();
    var taxes      = getTaxes(subtotal);
    var total      = subtotal + taxes.gst + taxes.qst;

    return fetch(ADMIN_CHECKOUT_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        customer_name:  name,
        customer_email: email,
        customer_phone: phone,
        pickup_datetime: pickup,
        notes: notes,
        payment_method: paymentStatus === 'online' ? 'online' : 'in_person',
        payment_status: 'pending',
        paypal_transaction_id: null,
        subtotal: subtotal,
        gst: taxes.gst,
        qst: taxes.qst,
        service_fee: 0,
        total: total,
        locale: CONFIG.locale,
        referral_source: val('oc-referral') || '',
        items: expandCartItemsForSubmit(items),
      }),
    }).then(function (res) { return res.json(); });
  }

  // Convert cart items into the admin API's order_items shape. Packages
  // produce a priced "header" row plus zero-priced child rows — one per
  // contained item — carrying each item's option selections.
  function expandCartItemsForSubmit(items) {
    var rows = [];
    items.forEach(function (i) {
      var isPkg = i.id && i.id.indexOf('pkg-') === 0;
      if (isPkg) {
        var pkg = pkgByHandle[i.id.replace(/^pkg-/, '')];
        rows.push({
          item_id:    i.id,
          item_name:  i.name,
          quantity:   i.qty,
          unit_price: i.price,
          line_total: lineTotal(i),
          comment:    i.comment || '',
          options:    [],
        });
        if (pkg && pkg.items) {
          var picks = cartPackageOptions[i.id] || {};
          pkg.items.forEach(function (pi) {
            // Suggested add-ons aren't included contents — their picks ride
            // as ordinary priced lines from getCartItems.
            if (pi.suggested) return;
            var isFr = CONFIG.locale === 'fr';
            var piName = (isFr && pi.name_fr) ? pi.name_fr : pi.name_en;
            var piOpts = packageItemOptionsForSubmit(pi, picks[pi.id]);
            // The kitchen makes what was PICKED: over-target multi-qty
            // selections raise the made quantity past the included count
            // (the upcharge is already in the package line's total).
            var made = pi.quantity * i.qty;
            piOpts.forEach(function (o) {
              if (o.type !== 'multi_qty' || !o.selections) return;
              var s = 0;
              Object.keys(o.selections).forEach(function (k) { s += o.selections[k] || 0; });
              if (s > made) made = s;
            });
            rows.push({
              item_id:    pi.id,
              item_name:  piName,
              quantity:   made,
              unit_price: 0,
              line_total: 0,
              comment:    'Included in ' + i.name,
              options:    piOpts,
            });
          });
        }
        return;
      }
      rows.push({
        item_id:    i.id,
        item_name:  i.name,
        quantity:   i.qty,
        unit_price: i.price,
        line_total: i.qty * i.price,
        comment:    i.comment || '',
        options:    (i.options && i.options.length > 0) ? i.options.map(function (o) {
          if (o.type === 'radio') {
            return { group: o.group_en, type: 'radio', selected: o.selected };
          } else {
            return { group: o.group_en, type: 'multi_qty', selections: o.selections };
          }
        }) : [],
      });
    });
    return rows;
  }

  // ─── Success screen ───────────────────────────────────────────────────────

  function showSuccess(opts) {
    var txnId = opts.txnId || '—';
    var paymentStatus = opts.paymentStatus || 'in_person';
    var orderId = opts.orderId || '';

    var bodyEl    = root.querySelector('.catering-order__body');
    var successEl = document.getElementById('oc-success');
    if (!bodyEl || !successEl) return;

    var name   = val('oc-name').trim();
    var email  = val('oc-email').trim();
    var pickup = val('oc-pickup');
    var items  = getCartItems();

    var subtotal   = getCartTotal();
    var taxes      = getTaxes(subtotal);
    var total      = subtotal + taxes.gst + taxes.qst;

    var subtotalLabel = CONFIG.locale === 'fr' ? 'Sous-total' : 'Subtotal';
    var paymentLabel  = paymentStatus === 'online'
      ? (CONFIG.locale === 'fr' ? 'Payé en ligne (carte)' : 'Paid online (card)')
      : (CONFIG.locale === 'fr' ? 'Paiement à la livraison' : 'Pay on pickup');

    document.getElementById('oc-success-name').textContent   = name;
    document.getElementById('oc-success-email').textContent  = email;
    document.getElementById('oc-success-pickup').textContent = pickup;
    document.getElementById('oc-success-total').textContent  = fmt(total);

    var orderIdEl = document.getElementById('oc-success-order-id');
    if (orderIdEl) orderIdEl.textContent = orderId;

    var statusEl = document.getElementById('oc-success-payment-status');
    if (statusEl) statusEl.textContent = paymentLabel;

    var txnRowEl = document.getElementById('oc-success-txn-row');
    var txnEl    = document.getElementById('oc-success-txn');
    if (txnRowEl) txnRowEl.style.display = paymentStatus === 'online' ? 'block' : 'none';
    if (txnEl)    txnEl.textContent = txnId;

    document.getElementById('oc-success-items').innerHTML = [].concat(
      items.map(function (i) {
        var line = '<div class="order-line"><span>' + i.qty + ' × ' + i.name + '</span><span>' + fmt(i.qty * i.price) + '</span></div>';
        if (i.id.indexOf('pkg-') === 0) line += formatPackageOptionsSummaryHtml(i.id);
        if (i.options && i.options.length > 0) line += formatOptionsSummaryHtml(i.options);
        if (i.comment) line += '<div class="order-line-comment">' + i.comment.replace(/</g, '&lt;') + '</div>';
        return line;
      }),
      ['<hr class="summary-divider">'],
      ['<div class="order-line summary-tax-line"><span>' + subtotalLabel + '</span><span>' + fmt(subtotal) + '</span></div>'],
      ['<div class="order-line summary-tax-line"><span>GST (5%)</span><span>' + fmt(taxes.gst) + '</span></div>'],
      ['<div class="order-line summary-tax-line"><span>QST (9.975%)</span><span>' + fmt(taxes.qst) + '</span></div>']
    ).join('');

    bodyEl.style.display = 'none';
    successEl.classList.add('visible');
    successEl.scrollIntoView({ behavior: 'smooth', block: 'start' });

    var stickyBar = document.getElementById('oc-sticky-bar');
    if (stickyBar) stickyBar.style.display = 'none';
  }

  // ─── Order ID ─────────────────────────────────────────────────────────────

  function generateOrderId() {
    var now  = new Date();
    var date = now.getFullYear().toString()
      + String(now.getMonth() + 1).padStart(2, '0')
      + String(now.getDate()).padStart(2, '0');
    var rand = Math.random().toString(36).slice(2, 6).toUpperCase();
    return 'CG-' + date + '-' + rand;
  }

  // ─── Form error highlight ─────────────────────────────────────────────────

  function validateMinQty() {
    var errors = [];
    var isFr = CONFIG.locale === 'fr';
    Object.keys(cart).forEach(function (id) {
      var qty = cart[id];
      if (qty <= 0 || !menuItems[id]) return;

      // Min qty check
      if (menuItems[id].minQty > 0 && qty < menuItems[id].minQty) {
        errors.push(menuItems[id].name + ' — ' + 'minimum ' + menuItems[id].minQty);
      }

      // (multi_qty validation not needed — sub-qty sums drive the item total directly)
    });

    // Packages: every multi-qty option group must be fully selected for the
    // current package count. The old modal enforced this before the package
    // could be added; the inline panel defers it to here, where the panel's
    // own red "Select N more" hint has already been telling the user.
    Object.keys(cart).forEach(function (id) {
      if (cart[id] <= 0 || id.indexOf('pkg-') !== 0) return;
      var pkg = pkgByHandle[id.replace(/^pkg-/, '')];
      if (!pkg) return;
      var picks = cartPackageOptions[id] || {};
      var pkgName = (isFr && pkg.name_fr) ? pkg.name_fr : pkg.name_en;
      (pkg.items || []).forEach(function (pi) {
        if (pi.suggested) return; // add-ons have no minimum
        if (!pi.option_groups || pi.option_groups.length === 0) return;
        var target = pi.quantity * cart[id];
        pi.option_groups.forEach(function (g) {
          if (groupSelectionType(g) !== 'multi_qty') return;
          var key = g.handle || slugify(g.name_en);
          var data = picks[pi.id] && picks[pi.id][key];
          var sum = 0;
          if (data && data.selections) {
            Object.keys(data.selections).forEach(function (k) { sum += data.selections[k]; });
          }
          // Under the included count blocks; over is fine — extras are
          // charged à la carte.
          if (sum < target) {
            var piName = (isFr && pi.name_fr) ? pi.name_fr : pi.name_en;
            errors.push(pkgName + ' — ' + piName + ': ' + sum + ' / ' + target);
          }
        });
      });
    });

    if (errors.length > 0) {
      var heading = isFr
        ? 'Veuillez corriger :'
        : 'Please fix the following:';
      alert(heading + '\n\n' + errors.join('\n'));
      return false;
    }
    return true;
  }

  function highlightErrors() {
    ['oc-name', 'oc-email', 'oc-phone', 'oc-pickup'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      if (!el.value.trim()) {
        el.classList.add('error');
      } else {
        el.classList.remove('error');
      }
    });
    // If the picked pickup time doesn't satisfy a cart item's lead time,
    // flag the pickup field even though it has a value.
    if (getPickupLeadShortfallHours() > 0) {
      var pe = document.getElementById('oc-pickup');
      if (pe) pe.classList.add('error');
    }
  }

  // ─── Event handlers ───────────────────────────────────────────────────────

  function toggleItemExtras(itemId) {
    var qty = cart[itemId] || 0;
    var itemEl = root.querySelector('[data-item-id="' + itemId + '"]');
    var isMultiQty = itemEl && itemEl.dataset.multiQty === '1';
    var isFr = CONFIG.locale === 'fr';

    // Comment field
    var commentEl = root.querySelector('[data-comment-for="' + itemId + '"]');
    if (commentEl) {
      commentEl.style.display = qty > 0 ? '' : 'none';
      if (qty === 0) {
        var input = commentEl.querySelector('.menu-item__comment-input');
        if (input) { input.value = ''; }
        delete itemComments[itemId];
      }
    }

    if (isMultiQty) {
      // Update the select button text and badge
      var selectBtn = root.querySelector('[data-select-for="' + itemId + '"]');
      if (selectBtn) {
        if (qty > 0) {
          selectBtn.textContent = isFr ? 'Modifier' : 'Edit Selection';
          selectBtn.classList.add('menu-item__select-btn--active');
        } else {
          selectBtn.textContent = isFr ? 'Sélectionner' : 'Make Selection(s)';
          selectBtn.classList.remove('menu-item__select-btn--active');
        }
      }
      updateTotalBadge(itemId);

      // If qty dropped to 0, collapse options and reset
      if (qty === 0) {
        var optionsEl = root.querySelector('[data-options-for="' + itemId + '"]');
        if (optionsEl) {
          optionsEl.style.display = 'none';
          optionsEl.querySelectorAll('.qty-value').forEach(function (el) { el.textContent = '0'; });
          // Also reset radios within the same panel
          optionsEl.querySelectorAll('input[type="radio"]').forEach(function (el) {
            el.checked = el.value === el.parentElement.parentElement.querySelector('input[type="radio"]').value;
          });
        }
        delete cartOptions[itemId];
      }
    } else {
      // Radio-only items: toggle options panel with qty
      var optionsEl = root.querySelector('[data-options-for="' + itemId + '"]');
      if (optionsEl) {
        optionsEl.style.display = qty > 0 ? '' : 'none';
        if (qty > 0) {
          initCartOptions(itemId);
        } else {
          delete cartOptions[itemId];
          optionsEl.querySelectorAll('.qty-value').forEach(function (el) { el.textContent = '0'; });
          optionsEl.querySelectorAll('input[type="radio"]').forEach(function (el) {
            el.checked = el.value === el.parentElement.parentElement.querySelector('input[type="radio"]').value;
          });
        }
      }
      // Inline size buttons sit outside the panel (which may not even exist
      // for a size-only item): seed options and re-sync from the visible
      // checked radio on every add, since the reset above wipes cartOptions
      // without touching these radios.
      if (qty > 0) {
        initCartOptions(itemId);
        syncInlineSizeSelection(itemId);
      }
    }
  }

  function syncMultiQtyTotal(itemId) {
    // Compute item qty as sum of all multi_qty selections
    var opts = cartOptions[itemId];
    var groups = itemOptionGroups[itemId];
    if (!opts || !groups) return;
    var total = 0;
    groups.forEach(function (g) {
      if (g.type !== 'multi_qty') return;
      var key = g.handle || slugify(g.name_en);
      var data = opts[key];
      if (!data || !data.selections) return;
      Object.keys(data.selections).forEach(function (k) { total += data.selections[k]; });
    });
    cart[itemId] = total;
    updateTotalBadge(itemId);
    toggleItemExtras(itemId);
  }

  function updateTotalBadge(itemId) {
    var badge = root.querySelector('[data-total-for="' + itemId + '"]');
    if (!badge) return;
    var qty = cart[itemId] || 0;
    if (qty > 0) {
      badge.textContent = qty;
      badge.style.display = '';
    } else {
      badge.textContent = '';
      badge.style.display = 'none';
    }
  }

  // ─── Package option configuration ────────────────────────────────────────

  function packageNeedsConfiguration(pkg) {
    if (!pkg || !pkg.items) return false;
    return pkg.items.some(function (pi) {
      // An unpriced suggestion can't be sold (unknown ≠ free), so it never
      // creates a panel on its own.
      return (pi.suggested && pi.price > 0) ||
        (!pi.suggested && pi.option_groups && pi.option_groups.length > 0);
    });
  }

  // Translate a cart-options blob (for one item inside a package) into the
  // shape submitOrderToAdmin expects.
  function packageItemOptionsForSubmit(pi, opts) {
    if (!pi.option_groups || pi.option_groups.length === 0 || !opts) return [];
    return pi.option_groups.map(function (g) {
      var key = g.handle || slugify(g.name_en);
      var data = opts[key];
      if (!data) return null;
      if (data.type === 'radio') {
        return { group: g.name_en, type: 'radio', selected: data.selected };
      }
      return { group: g.name_en, type: 'multi_qty', selections: data.selections };
    }).filter(Boolean);
  }

  // Seed cartPackageOptions[pkgId] with defaults — first radio choice,
  // zeroed multi-qty counts — for every option-bearing member, keeping any
  // picks already made. Idempotent, so it's safe to call on every add.
  function seedPackageOptions(pkgId) {
    var pkg = pkgByHandle[pkgId.replace(/^pkg-/, '')];
    if (!pkg) return;
    var existing = cartPackageOptions[pkgId] || {};
    var state = {};
    (pkg.items || []).forEach(function (pi) {
      // Suggested add-ons carry no option state — their picks live in
      // cartPackageExtras as plain counts.
      if (pi.suggested) return;
      if (!pi.option_groups || pi.option_groups.length === 0) return;
      var itemState = {};
      var prior = existing[pi.id] || {};
      pi.option_groups.forEach(function (g) {
        var key = g.handle || slugify(g.name_en);
        var priorData = prior[key];
        var choices = [];
        try { choices = JSON.parse(g.choices_json || '[]'); } catch (_) { choices = []; }
        if (groupSelectionType(g) === 'radio') {
          var firstKey = choices.length > 0 ? slugify(choices[0].name_en) : '';
          itemState[key] = {
            type: 'radio',
            selected: (priorData && priorData.selected) || firstKey,
          };
        } else {
          var sel = {};
          choices.forEach(function (c) {
            var k = slugify(c.name_en);
            sel[k] = (priorData && priorData.selections && priorData.selections[k]) || 0;
          });
          itemState[key] = { type: 'multi_qty', selections: sel };
        }
      });
      state[pi.id] = itemState;
    });
    cartPackageOptions[pkgId] = state;
    if (!cartPackageExtras[pkgId]) cartPackageExtras[pkgId] = {};
  }

  // Render the inline configuration panel for one package into its
  // [data-pkg-config] container. Live state: it reads and writes
  // cartPackageOptions[pkgId] directly — a pick takes effect the moment
  // it's made and the summary reprices immediately. This replaced the old
  // configuration modal (the "expand down like a platter" behaviour).
  function renderPackageConfig(pkgId) {
    var panel = root.querySelector('[data-pkg-config="' + pkgId + '"]');
    var pkg = pkgByHandle[pkgId.replace(/^pkg-/, '')];
    var state = cartPackageOptions[pkgId];
    if (!panel || !pkg || !state) return;
    var isFr = CONFIG.locale === 'fr';
    var effectiveQty = Math.max(1, cart[pkgId] || 1);
    var html = '';
    (pkg.items || []).forEach(function (pi) {
      if (pi.suggested || !pi.option_groups || pi.option_groups.length === 0 || !state[pi.id]) return;
      var piName = (isFr && pi.name_fr) ? pi.name_fr : pi.name_en;
      var totalForItem = pi.quantity * effectiveQty;
      html += '<div class="pkg-config-item" data-item="' + escAttr(pi.id) + '">';
      html += '<div class="pkg-config-item-head">' + esc(piName) +
        ' <span class="pkg-config-item-qty">× ' + totalForItem +
        (effectiveQty > 1
          ? ' <span class="pkg-config-item-qty-breakdown">(' + pi.quantity +
            ' × ' + effectiveQty + ' packages)</span>'
          : '') +
        '</span></div>';
      pi.option_groups.forEach(function (g) {
        var key = g.handle || slugify(g.name_en);
        var groupName = (isFr && g.name_fr) ? g.name_fr : g.name_en;
        html += '<div class="pkg-config-group" data-group="' + escAttr(key) + '">';
        html += '<div class="pkg-config-group-label">' + esc(groupName) + '</div>';
        var choices = [];
        try { choices = JSON.parse(g.choices_json || '[]'); } catch (_) { choices = []; }
        if (groupSelectionType(g) === 'radio') {
          var selected = state[pi.id][key].selected;
          choices.forEach(function (c) {
            var ckey = slugify(c.name_en);
            var cName = (isFr && c.name_fr) ? c.name_fr : c.name_en;
            html += '<label class="pkg-config-choice">';
            html += '<input type="radio" name="' + escAttr(pkgId + '-' + pi.id + '-' + key) + '"' +
              ' data-item="' + escAttr(pi.id) + '" data-group="' + escAttr(key) +
              '" data-choice="' + escAttr(ckey) + '"' +
              (selected === ckey ? ' checked' : '') + '>';
            html += '<span class="pkg-config-choice-name">' + esc(cName) + '</span>';
            if (c.price_adj) {
              html += '<span class="pkg-config-choice-adj">+$' + Number(c.price_adj).toFixed(2) + '</span>';
            }
            html += '</label>';
          });
        } else {
          var sel = state[pi.id][key].selections;
          var total = 0;
          Object.keys(sel).forEach(function (k) { total += sel[k]; });
          var atTarget = total >= totalForItem;
          var extraN = Math.max(0, total - totalForItem);
          // Over-selection is only for sale when the item has a known
          // à-la-carte price — unknown must never be sold as free, so an
          // unpriced item keeps the hard cap at the included count.
          var canExceed = pi.price > 0;
          html += '<div class="pkg-config-multi' + (atTarget ? ' is-at-limit' : '') +
            '" data-item="' + escAttr(pi.id) + '" data-group="' + escAttr(key) + '">';
          choices.forEach(function (c) {
            var ckey = slugify(c.name_en);
            var cName = (isFr && c.name_fr) ? c.name_fr : c.name_en;
            var val = sel[ckey] || 0;
            var decDisabled = val <= 0;
            var incDisabled = !canExceed && atTarget;
            html += '<div class="pkg-config-multi-row">';
            html += '<span class="pkg-config-choice-name">' + esc(cName);
            if (c.price_adj) {
              html += ' <span class="pkg-config-choice-adj">+$' + Number(c.price_adj).toFixed(2) + '</span>';
            }
            html += '</span>';
            html += '<div class="pkg-config-multi-controls">';
            html += '<button type="button" class="pkg-config-dec" data-item="' + escAttr(pi.id) + '" data-group="' + escAttr(key) + '" data-choice="' + escAttr(ckey) + '"' + (decDisabled ? ' disabled' : '') + '>−</button>';
            html += '<span class="pkg-config-multi-val">' + val + '</span>';
            html += '<button type="button" class="pkg-config-inc" data-item="' + escAttr(pi.id) + '" data-group="' + escAttr(key) + '" data-choice="' + escAttr(ckey) + '"' + (incDisabled ? ' disabled' : '') + '>+</button>';
            html += '</div></div>';
          });
          var msg;
          var valid = total >= totalForItem;
          if (extraN > 0) {
            var unit = pi.price || 0;
            var extraCost = extraN * unit;
            msg = isFr
              ? ('+' + extraN + ' en sus' + (unit > 0 ? ' — +$' + extraCost.toFixed(2) + ' à la carte' : ''))
              : ('+' + extraN + ' extra' + (unit > 0 ? ' — +$' + extraCost.toFixed(2) + ' à la carte' : ''));
          } else if (valid) {
            msg = isFr ? 'Sélection complète' : 'Selection complete';
          } else {
            msg = isFr
              ? ('Sélectionnez ' + (totalForItem - total) + ' de plus (' + total + ' / ' + totalForItem + ')')
              : ('Select ' + (totalForItem - total) + ' more (' + total + ' / ' + totalForItem + ')');
          }
          html += '<div class="pkg-config-multi-hint ' + (valid ? 'is-ok' : 'is-bad') + '">' + esc(msg) + '</div>';
          html += '</div>';
        }
        html += '</div>';
      });
      html += '</div>';
    });

    // Suggested add-ons (109): optional extras at à-la-carte price, minimum
    // zero. Counts live in cartPackageExtras and become their own priced
    // lines in the summary and the submitted order.
    var suggestions = (pkg.items || []).filter(function (pi) {
      // Unpriced = unsellable (unknown ≠ free) — don't offer it.
      return pi.suggested && pi.price > 0;
    });
    if (suggestions.length > 0) {
      var extras = cartPackageExtras[pkgId] || {};
      html += '<div class="pkg-config-item pkg-config-suggested">';
      html += '<div class="pkg-config-item-head">' +
        esc(isFr ? 'Ajoutez à votre commande' : 'Add to your order') +
        ' <span class="pkg-config-item-qty">' + esc(isFr ? 'à la carte' : 'à la carte') + '</span></div>';
      // Suggestions arrive pre-ordered by add-on group (110) — insert a
      // heading whenever the group label changes; ungrouped ones lead.
      var prevGroup = '';
      suggestions.forEach(function (pi) {
        var groupLabel = pi.section
          ? (isFr ? (pi.section.fr || pi.section.en) : (pi.section.en || pi.section.fr)) || ''
          : '';
        if (groupLabel && groupLabel !== prevGroup) {
          html += '<div class="pkg-config-addon-group"><span>' + esc(groupLabel) + '</span></div>';
        }
        prevGroup = groupLabel;
        var piName = (isFr && pi.name_fr) ? pi.name_fr : pi.name_en;
        var piDesc = (isFr && pi.desc_fr) ? pi.desc_fr : (pi.desc_en || '');
        var n = extras[pi.id] || 0;
        html += '<div class="pkg-config-multi-row">';
        html += '<span class="pkg-config-choice-name">' + esc(piName) +
          (pi.price > 0
            ? ' <span class="pkg-config-choice-adj">$' + pi.price.toFixed(2) + '</span>'
            : '') +
          (piDesc
            ? '<span class="pkg-config-addon-desc">' + esc(piDesc) + '</span>'
            : '') + '</span>';
        html += '<div class="pkg-config-multi-controls">';
        html += '<button type="button" class="pkg-config-dec" data-extra="' + escAttr(pi.id) + '"' + (n <= 0 ? ' disabled' : '') + '>−</button>';
        html += '<span class="pkg-config-multi-val">' + n + '</span>';
        html += '<button type="button" class="pkg-config-inc" data-extra="' + escAttr(pi.id) + '">+</button>';
        html += '</div></div>';
      });
      html += '</div>';
    }
    panel.innerHTML = html;
  }

  // Show the panel while the package is in the cart, re-rendering so
  // multi-qty targets track the current count; hide and clear it at zero —
  // the same lifecycle toggleItemExtras gives an item's options panel.
  function togglePackageConfig(pkgId) {
    var panel = root.querySelector('[data-pkg-config="' + pkgId + '"]');
    if (!panel) return;
    if ((cart[pkgId] || 0) > 0) {
      seedPackageOptions(pkgId);
      renderPackageConfig(pkgId);
      panel.style.display = '';
    } else {
      panel.style.display = 'none';
      panel.innerHTML = '';
    }
  }

  function attachQtyHandlers() {
    // Inline package config panels: one delegated listener pair per panel —
    // the panel's innerHTML re-renders freely underneath them. Picks write
    // straight into cartPackageOptions, so the summary reprices live.
    root.querySelectorAll('[data-pkg-config]').forEach(function (panel) {
      var pkgId = panel.dataset.pkgConfig;
      panel.addEventListener('change', function (e) {
        var t = e.target;
        if (!t.matches('input[type="radio"]')) return;
        var state = cartPackageOptions[pkgId];
        var data = state && state[t.dataset.item] && state[t.dataset.item][t.dataset.group];
        if (!data) return;
        data.selected = t.dataset.choice;
        renderSummary();
      });
      panel.addEventListener('click', function (e) {
        var t = e.target;
        if (!t.matches('.pkg-config-inc, .pkg-config-dec') || t.disabled) return;
        var delta = t.classList.contains('pkg-config-inc') ? 1 : -1;
        // Suggested add-on steppers: plain counts, charged à la carte.
        if (t.dataset.extra) {
          var extras = cartPackageExtras[pkgId] || (cartPackageExtras[pkgId] = {});
          extras[t.dataset.extra] = Math.max(0, (extras[t.dataset.extra] || 0) + delta);
          renderPackageConfig(pkgId);
          renderSummary();
          return;
        }
        var state = cartPackageOptions[pkgId];
        var data = state && state[t.dataset.item] && state[t.dataset.item][t.dataset.group];
        if (!data || data.type !== 'multi_qty') return;
        // Picks beyond the included count are charged at the item's
        // à-la-carte price (getPackageOptionsPriceAdj) — but only a KNOWN
        // price is sellable: an unpriced item keeps the hard cap (render
        // disables + at the limit; re-check defensively here).
        if (delta > 0) {
          var pkg = pkgByHandle[pkgId.replace(/^pkg-/, '')];
          var pi = pkg && (pkg.items || []).find(function (x) { return x.id === t.dataset.item; });
          if (pi && !(pi.price > 0)) {
            var target = pi.quantity * Math.max(1, cart[pkgId] || 1);
            var sum = 0;
            Object.keys(data.selections).forEach(function (k) { sum += data.selections[k]; });
            if (sum >= target) return;
          }
        }
        data.selections[t.dataset.choice] = Math.max(0, (data.selections[t.dataset.choice] || 0) + delta);
        renderPackageConfig(pkgId);
        renderSummary();
      });
    });

    // Main item qty controls (skip sub-qty controls inside option groups)
    root.querySelectorAll('[data-qty-item]').forEach(function (control) {
      if (control.dataset.subQty) return; // handled separately below
      var itemId  = control.dataset.qtyItem;
      var valueEl = control.querySelector('.qty-value');
      var minus   = control.querySelector('.qty-minus');
      var plus    = control.querySelector('.qty-plus');

      minus.addEventListener('click', function () {
        if ((cart[itemId] || 0) > 0) {
          cart[itemId]--;
          valueEl.textContent = cart[itemId];
          // Dropping a package to 0 clears its options and add-on picks so
          // a subsequent + starts with a clean slate.
          if (cart[itemId] === 0 && itemId.indexOf('pkg-') === 0) {
            delete cartPackageOptions[itemId];
            delete cartPackageExtras[itemId];
          }
          // Panel tracks the count: re-renders targets, hides at zero.
          if (itemId.indexOf('pkg-') === 0) togglePackageConfig(itemId);
          toggleItemExtras(itemId);
          renderSummary();
        }
      });

      plus.addEventListener('click', function () {
        cart[itemId] = (cart[itemId] || 0) + 1;
        valueEl.textContent = cart[itemId];
        // A package with option-bearing items expands its inline config
        // panel below the contents — same behaviour as an item's options
        // panel. Re-rendered on every bump: multi-qty targets scale with
        // the package count.
        if (itemId.indexOf('pkg-') === 0) {
          togglePackageConfig(itemId);
          // First add: scroll the package controls to the top of the view
          // (with breathing room) so the freshly-expanded options panel is
          // what the user sees next. Only when there IS a panel to see.
          if (cart[itemId] === 1) {
            var panelEl = root.querySelector('[data-pkg-config="' + itemId + '"]');
            if (panelEl && panelEl.innerHTML !== '') {
              var y = control.getBoundingClientRect().top + window.pageYOffset - 96;
              window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
            }
          }
        }
        toggleItemExtras(itemId);
        renderSummary();
      });
    });

    // Sub-qty controls for multi_qty option groups
    root.querySelectorAll('[data-sub-qty]').forEach(function (control) {
      var itemId    = control.dataset.subQty;
      var groupKey  = control.dataset.subGroup;
      var choiceKey = control.dataset.subChoice;
      var valueEl   = control.querySelector('.qty-value');
      var minus     = control.querySelector('.qty-minus');
      var plus      = control.querySelector('.qty-plus');

      minus.addEventListener('click', function () {
        initCartOptions(itemId);
        var data = cartOptions[itemId] && cartOptions[itemId][groupKey];
        if (!data || !data.selections) return;
        if ((data.selections[choiceKey] || 0) > 0) {
          data.selections[choiceKey]--;
          valueEl.textContent = data.selections[choiceKey];
          syncMultiQtyTotal(itemId);
          renderSummary();
        }
      });

      plus.addEventListener('click', function () {
        initCartOptions(itemId);
        var data = cartOptions[itemId] && cartOptions[itemId][groupKey];
        if (!data || !data.selections) return;
        data.selections[choiceKey] = (data.selections[choiceKey] || 0) + 1;
        valueEl.textContent = data.selections[choiceKey];
        syncMultiQtyTotal(itemId);
        renderSummary();
      });
    });

    // Radio option handlers
    root.querySelectorAll('.option-group[data-option-type="radio"]').forEach(function (groupEl) {
      groupEl.querySelectorAll('input[type="radio"]').forEach(function (radio) {
        radio.addEventListener('change', function () {
          var wrap = groupEl.closest('[data-options-for]');
          if (!wrap) return;
          var itemId = wrap.dataset.optionsFor;
          var groupKey = groupEl.dataset.optionGroup;
          initCartOptions(itemId);
          if (cartOptions[itemId] && cartOptions[itemId][groupKey]) {
            cartOptions[itemId][groupKey].selected = radio.value;
          }
          renderSummary();
        });
      });
    });

    // "Make Selection(s)" toggle buttons for multi_qty items
    root.querySelectorAll('[data-select-for]').forEach(function (btn) {
      var itemId = btn.dataset.selectFor;
      btn.addEventListener('click', function () {
        var optionsEl = root.querySelector('[data-options-for="' + itemId + '"]');
        if (!optionsEl) return;
        var isOpen = optionsEl.style.display !== 'none';
        optionsEl.style.display = isOpen ? 'none' : '';
        initCartOptions(itemId);
      });
    });

    // Attach comment input listeners
    root.querySelectorAll('[data-comment-for]').forEach(function (commentEl) {
      var itemId = commentEl.dataset.commentFor;
      var input = commentEl.querySelector('.menu-item__comment-input');
      if (input) {
        input.addEventListener('input', function () {
          itemComments[itemId] = input.value;
        });
      }
    });
  }

  // ─── Prefill the cart from ?qty= (latke box → sides page) ────────────────
  //
  // The Chanukkah latke box (/pages/latkes, sections/latke-box.liquid) lets a
  // customer pick how many latkes they want, then links here — an ordinary
  // catering page (/pages/chanukkah) — to add sides and check out. The count
  // rides in the link:
  //
  //   /pages/chanukkah?qty=latkes:12
  //
  // `qty` is a comma-separated list of itemHandle:count pairs. The handle is
  // the item's `id` in /api/menu — the cart key (adaptPayloadForRender maps
  // it to `handle`); a package would be `pkg-<handle>`. Each known handle with
  // a whole count > 0 goes into the cart as if + had been pressed that many
  // times: default (first) size and option choices, options panel open. The
  // count is raised to the item's min_qty and capped at QTY_PREFILL_MAX.
  // Skipped with a console warning, leaving the page to load normally:
  // malformed pairs, handles not on this menu (typo, old link, item dropped
  // from the menu), and multi-selection items, whose count comes from their
  // picks rather than a qty control.
  //
  // The first prefilled item's accordion category is opened so the customer
  // sees the count already set; the page is deliberately not scrolled. Runs
  // once, after initMenu() has rendered the menu and attached the qty
  // handlers. Independent of ?preview= — both can share one URL.
  var QTY_PREFILL_MAX = 500;
  var qtyPrefillDone = false;

  function applyQtyFromUrl() {
    if (qtyPrefillDone) return;
    qtyPrefillDone = true;
    var raw = '';
    try {
      raw = (new URLSearchParams(window.location.search).get('qty') || '').trim();
    } catch (_) {}
    if (!raw) return;

    var firstControl = null;
    raw.split(',').forEach(function (pair) {
      pair = pair.trim();
      if (!pair) return;
      var sep = pair.lastIndexOf(':');
      var itemId = sep > 0 ? pair.slice(0, sep).trim() : '';
      var countStr = sep > 0 ? pair.slice(sep + 1).trim() : '';
      if (!itemId || !/^\d+$/.test(countStr)) {
        console.warn('[qty] Ignoring malformed pair:', pair);
        return;
      }
      var count = parseInt(countStr, 10);
      if (!(count > 0)) return;
      if (!Object.prototype.hasOwnProperty.call(menuItems, itemId)) {
        console.warn('[qty] Not on this menu, ignored:', itemId);
        return;
      }
      var control = root.querySelector('[data-qty-item="' + itemId + '"]');
      if (!control) {
        console.warn('[qty] No quantity control (multi-selection item), ignored:', itemId);
        return;
      }
      var minQty = menuItems[itemId].minQty || 0;
      if (count < minQty) count = minQty;
      if (count > QTY_PREFILL_MAX) count = QTY_PREFILL_MAX;

      // Same steps as the + handler in attachQtyHandlers, minus its
      // first-add scroll for packages.
      cart[itemId] = count;
      var valueEl = control.querySelector('.qty-value');
      if (valueEl) valueEl.textContent = count;
      if (itemId.indexOf('pkg-') === 0) togglePackageConfig(itemId);
      toggleItemExtras(itemId);
      if (!firstControl) firstControl = control;
    });
    if (!firstControl) return;

    // Accordion categories render collapsed; open the first prefilled item's.
    // The others are all still closed at this point, so the one-open-at-a-time
    // rule of the title click handler holds.
    var cat = firstControl.closest('.menu-category');
    if (cat && cat.classList.contains('collapsed')) cat.classList.remove('collapsed');

    renderSummary();
  }

  function attachFormHandlers() {
    function scrollToCheckout() {
      if (!validateMinQty()) return;
      var formEl = document.getElementById('oc-checkout-form');
      if (!formEl) return;
      var headerEl = document.querySelector('.shopify-section-header');
      var headerHeight = headerEl ? headerEl.offsetHeight : 0;
      var top = formEl.getBoundingClientRect().top + window.scrollY - headerHeight - 20;
      window.scrollTo({ top: top, behavior: 'smooth' });
      setTimeout(function () {
        var first = ['oc-name', 'oc-email', 'oc-phone', 'oc-pickup']
          .map(function (id) { return document.getElementById(id); })
          .find(function (el) { return el && !el.value.trim(); });
        if (first) first.focus();
      }, 600);
    }

    var continueBtn = document.getElementById('oc-continue-btn');
    if (continueBtn) continueBtn.addEventListener('click', scrollToCheckout);

    var stickyContinueBtn = document.getElementById('oc-sticky-continue');
    if (stickyContinueBtn) stickyContinueBtn.addEventListener('click', scrollToCheckout);

    ['oc-name', 'oc-email', 'oc-phone', 'oc-pickup'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      el.addEventListener('input', function () {
        el.classList.remove('error');
        updatePaymentZone();
      });
      el.addEventListener('change', function () {
        el.classList.remove('error');
        updatePaymentZone();
      });
    });

    // Auto-format phone as NXX-NXX-XXXX. Autofill hands us the country code
    // ("+1 514-555-1234"), so drop a leading North American 1 before taking
    // ten digits — otherwise the 1 occupies a slot and the last digit falls
    // off the end.
    var phoneEl = document.getElementById('oc-phone');
    if (phoneEl) {
      var formatPhone = function (el) {
        var v = el.value.replace(/\D/g, '');
        if (v.length > 10 && v.charAt(0) === '1') v = v.slice(1);
        v = v.slice(0, 10);
        if (v.length <= 3)       el.value = v;
        else if (v.length <= 6)  el.value = v.slice(0, 3) + '-' + v.slice(3);
        else                     el.value = v.slice(0, 3) + '-' + v.slice(3, 6) + '-' + v.slice(6);
      };
      phoneEl.addEventListener('input', function () { formatPhone(this); });
      // Some browsers fill the field without firing 'input'.
      phoneEl.addEventListener('change', function () { formatPhone(this); });
    }
  }

  function attachPaymentMethodHandlers() {
    document.querySelectorAll('input[name="oc-payment-method"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        paymentMethod = radio.value;
        renderSummary();
      });
    });

    var placeOrderBtn = document.getElementById('oc-place-order-btn');
    if (placeOrderBtn) {
      placeOrderBtn.addEventListener('click', function () {
        runCheckout('in_person', placeOrderBtn);
      });
    }

    var payOnlineBtn = document.getElementById('oc-pay-online-btn');
    if (payOnlineBtn) {
      payOnlineBtn.addEventListener('click', function () {
        runCheckout('online', payOnlineBtn);
      });
    }
  }

  // ─── Pickup options (dynamic, generated from rules) ──────────────────────

  function generatePickupSlots() {
    var MIN_LEAD_HOURS = 48;
    var DAYS_TO_GENERATE = 14;

    var now = new Date();
    var earliest = new Date(now.getTime() + MIN_LEAD_HOURS * 60 * 60 * 1000);
    var slots = [];

    for (var d = 0; d < DAYS_TO_GENERATE; d++) {
      var date = new Date(earliest);
      date.setDate(earliest.getDate() + d);
      date.setHours(0, 0, 0, 0);

      var dayOfWeek = date.getDay(); // 0=Sun, 6=Sat
      var isWeekend = dayOfWeek === 0 || dayOfWeek === 6;

      // Build list of {h, m} slots for this day
      var daySlots = [];
      if (isWeekend) {
        // 8:30–10:30, on the half hour
        addSlots(daySlots, 8, 30, 10, 30);
        // 2:30–4:30, on the half hour
        addSlots(daySlots, 14, 30, 16, 30);
      } else {
        // Weekdays: 8:30–3:30, on the half hour
        addSlots(daySlots, 8, 30, 15, 30);
      }

      for (var i = 0; i < daySlots.length; i++) {
        var slot = new Date(date);
        slot.setHours(daySlots[i].h, daySlots[i].m, 0, 0);
        if (slot > earliest) {
          slots.push(slot);
        }
      }
    }
    return slots;
  }

  function addSlots(arr, startH, startM, endH, endM) {
    var h = startH;
    var m = startM;
    while (h < endH || (h === endH && m <= endM)) {
      arr.push({ h: h, m: m });
      m += 30;
      if (m >= 60) { m = 0; h++; }
    }
  }

  function formatSlotLabel(date) {
    var days = CONFIG.locale === 'fr'
      ? ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi']
      : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var months = CONFIG.locale === 'fr'
      ? ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre']
      : ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    var h = date.getHours();
    var m = date.getMinutes();
    var timeStr;
    if (CONFIG.locale === 'fr') {
      timeStr = h + ':' + (m < 10 ? '0' : '') + m;
    } else {
      var ampm = h >= 12 ? 'PM' : 'AM';
      var h12 = h % 12 || 12;
      timeStr = h12 + ':' + (m < 10 ? '0' : '') + m + ' ' + ampm;
    }

    return days[date.getDay()] + ', ' + months[date.getMonth()] + ' ' + date.getDate() + ' — ' + timeStr;
  }

  function setupPickupOptions() {
    var pickupEl = document.getElementById('oc-pickup');
    if (!pickupEl) return;

    var slots = generatePickupSlots();
    var placeholder = CONFIG.locale === 'fr' ? 'Planifiez votre ramassage' : 'Schedule your pickup';
    pickupEl.innerHTML = '<option value="">' + placeholder + '</option>' +
      slots.map(function (slot) {
        var label = formatSlotLabel(slot);
        var y = slot.getFullYear();
        var mo = String(slot.getMonth() + 1).padStart(2, '0');
        var d = String(slot.getDate()).padStart(2, '0');
        var h = String(slot.getHours()).padStart(2, '0');
        var mi = String(slot.getMinutes()).padStart(2, '0');
        var val = y + '-' + mo + '-' + d + 'T' + h + ':' + mi;
        return '<option value="' + val + '">' + label + '</option>';
      }).join('');
  }

  // ─── Cutoff check ────────────────────────────────────────────────────────

  function checkCutoff() {
    if (!CONFIG.enableCutoff || !CONFIG.cutoffDatetime) return;

    var cutoff = new Date(CONFIG.cutoffDatetime);
    if (isNaN(cutoff.getTime())) return;

    if (new Date() > cutoff) {
      var bodyEl   = root.querySelector('.catering-order__body');
      var closedEl = document.getElementById('oc-orders-closed');
      if (bodyEl)   bodyEl.style.display   = 'none';
      if (closedEl) {
        var headlineEl = closedEl.querySelector('.orders-closed__headline');
        if (headlineEl && !headlineEl.textContent.trim()) {
          headlineEl.textContent = CONFIG.closedMessage;
        }
        closedEl.style.display = 'block';
      }
    }
  }

  // ─── Init ─────────────────────────────────────────────────────────────────

  function initImageModal() {
    var modal = document.getElementById('oc-image-modal');
    if (!modal) return;
    // Move to <body> so the fixed overlay covers the true viewport (a
    // transformed section ancestor would otherwise scope position:fixed and
    // clip/mis-centre the image) and sits above the sticky site header.
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
    var img = modal.querySelector('.oc-modal__img');
    var backdrop = modal.querySelector('.oc-modal__backdrop');
    var closeBtn = modal.querySelector('.oc-modal__close');

    function open(src, alt) {
      img.src = src;
      img.alt = alt || '';
      modal.style.display = '';
    }

    function close() {
      modal.style.display = 'none';
      img.src = '';
    }

    backdrop.addEventListener('click', close);
    closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.style.display !== 'none') close();
    });

    root.querySelectorAll('.menu-item__image[data-full-src]').forEach(function (el) {
      el.addEventListener('click', function () {
        open(el.dataset.fullSrc, el.querySelector('img').alt);
      });
    });
  }

  // ─── Sticky section nav (scroll-spy) ──────────────────────────────────────
  // The scroll/resize listeners are bound once (sectionNavBound) and read the
  // current nav from the DOM each tick, so a re-render (e.g. locale switch)
  // never stacks duplicate listeners.

  var sectionNavBound = false;

  function sectionNavUpdate() {
    var nav = document.getElementById('oc-section-nav');
    if (!nav) return;
    // Shrink the tile photos smoothly as the bar approaches its pinned
    // position: full size while it's more than SHRINK_RANGE px below the pin,
    // scaling linearly to 0 exactly as it pins (its top reaches the sticky
    // offset — the CSS `top`, i.e. the site-header height). Scroll-linked via a
    // CSS variable, so it tracks the scroll rather than animating on a timer.
    var navRect = nav.getBoundingClientRect();
    var stuckTop = parseFloat(getComputedStyle(nav).top) || 0;
    var SHRINK_RANGE = 140;
    var imgScale = (navRect.top - stuckTop) / SHRINK_RANGE;
    imgScale = imgScale < 0 ? 0 : imgScale > 1 ? 1 : imgScale;
    nav.style.setProperty('--oc-nav-img', imgScale.toFixed(3));
    var items = nav.querySelectorAll('.oc-section-nav__item');
    if (!items.length) return;
    // A section is "active" once its top has scrolled up past just below the
    // nav; the last such section wins.
    var threshold = navRect.bottom + 24;
    var activeIdx = 0;
    for (var i = 0; i < items.length; i++) {
      var target = document.getElementById(items[i].getAttribute('data-target'));
      if (target && target.getBoundingClientRect().top <= threshold) activeIdx = i;
    }
    for (var j = 0; j < items.length; j++) {
      items[j].classList.toggle('is-active', j === activeIdx);
    }
    // When the nav overflows (many sections on a narrow screen), keep the
    // active tile centred — but only re-scroll when the active tile changes,
    // so a plain vertical scroll doesn't fight the horizontal one.
    if (activeIdx !== nav.__ocActiveIdx) {
      nav.__ocActiveIdx = activeIdx;
      if (nav.scrollWidth > nav.clientWidth + 4) {
        var active = items[activeIdx];
        var left = active.offsetLeft - (nav.clientWidth - active.offsetWidth) / 2;
        nav.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
      }
    }
  }

  function initSectionNav() {
    var nav = document.getElementById('oc-section-nav');
    if (!nav) return;
    nav.__ocActiveIdx = -1;
    nav.querySelectorAll('.oc-section-nav__item').forEach(function (item) {
      item.addEventListener('click', function (e) {
        var target = document.getElementById(item.getAttribute('data-target'));
        if (!target) return;
        e.preventDefault();
        // Land the section heading flush under the *pinned* bar. The bar
        // collapses to text-only as it pins, so its height at the end of the
        // scroll is its collapsed height — measure the destination in that
        // state (var forced to 0), which reflows but doesn't paint. Then
        // sectionNavUpdate() restores the var to match the current scroll
        // position, so the photos still shrink naturally during the scroll and
        // there's no flicker.
        nav.style.setProperty('--oc-nav-img', '0');
        var stuckTop = parseFloat(getComputedStyle(nav).top) || 0;
        var y =
          target.getBoundingClientRect().top +
          window.pageYOffset -
          stuckTop -
          nav.offsetHeight;
        window.scrollTo({ top: y < 0 ? 0 : y, behavior: 'smooth' });
        sectionNavUpdate();
      });
    });
    if (!sectionNavBound) {
      window.addEventListener('scroll', sectionNavUpdate, { passive: true });
      window.addEventListener('resize', sectionNavUpdate);
      sectionNavBound = true;
    }
    sectionNavUpdate();
  }

  function sortItemsByImage() {
    root.querySelectorAll('.menu-category__items').forEach(function (container) {
      var items = Array.from(container.children);
      items.sort(function (a, b) {
        var aImg = a.getAttribute('data-has-image') === '1' ? 0 : 1;
        var bImg = b.getAttribute('data-has-image') === '1' ? 0 : 1;
        return aImg - bImg;
      });
      items.forEach(function (item) { container.appendChild(item); });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    setupPickupOptions();
    checkCutoff();
    attachFormHandlers();
    attachPaymentMethodHandlers();
    renderSummary();

    // Load menu items
    function initMenu(pkgData, itemData) {
      console.log('[menu] Loaded', pkgData.length, 'packages,', itemData.length, 'items');
      renderMenu(pkgData, itemData);
      populateMenuItems();
      initImageModal();
      initSectionNav();
      attachQtyHandlers();
      renderSummary();
    }

    loadMenuFromApi().then(function (payload) {
      if (!payload) { showMenuError(); return; }
      var shaped = adaptPayloadForRender(payload);
      initMenu(shaped.packages, shaped.items);
      // ?qty=handle:count from the latke box (see applyQtyFromUrl).
      applyQtyFromUrl();
      // Online payment toggle (admin-controlled). Absent in older payloads →
      // default to enabled.
      var paymentCfg = (payload && payload.payment) || { online_enabled: true };
      applyPaymentConfig(paymentCfg.online_enabled !== false);
      // Mount the pickup picker once we have the API's pickup data. Falling
      // back to a permissive default if the API shape is older than phase 1.
      var pickup = (payload && payload.pickup) || {
        windows: [],
        operating_hours: [],
        buffer_hours: 48,
        start_date: null,
        end_date: null,
      };
      pageBufferHours = Number(pickup.buffer_hours) || 48;
      var pickupInput = document.getElementById('oc-pickup');
      if (pickupInput && window.ChezGPickupPicker) {
        window.ChezGPickupPicker.mount({
          input:  pickupInput,
          locale: CONFIG.locale,
          pickup: pickup,
          onChange: function () { renderSummary(); },
        });
      }
      // Re-evaluate the warning once the picker is wired up — the cart could
      // already have items if the user came back to the page.
      renderSummary();
    });

    // Move sticky bar to body for correct fixed positioning
    var stickyBar = document.getElementById('oc-sticky-bar');
    if (stickyBar) {
      document.body.appendChild(stickyBar);
    }
    if (stickyBar && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (stickyBar.style.display !== 'none') {
              stickyBar.style.visibility = entry.isIntersecting ? '' : 'hidden';
              stickyBar.style.pointerEvents = entry.isIntersecting ? '' : 'none';
            }
          });
        },
        { threshold: 0 }
      );
      observer.observe(root);
    }
  });
})();
